<template>
  <div class="box">
    <div class="top">
      <span>学生姓名：{{ studentInfo.realName }}</span>
      <span>联系电话：{{ studentInfo.contactPhone }}</span>
      <span>性别：{{ studentInfo.sex === 0 ? "男" : "女" }}</span>
      <span v-if="studentInfo.disciplineType === 1">科别：理科</span>
      <span v-if="studentInfo.disciplineType === 2">科别：文科</span>
      <span v-if="studentInfo.disciplineType === 0 ||
        studentInfo.disciplineType === 3 ||
        studentInfo.disciplineType === 4
        ">科目：<span v-if="studentInfo.discipline.includes('物理')">物理 </span><span
          v-if="studentInfo.discipline.includes('历史')">历史 </span>
        <span v-if="studentInfo.discipline.includes('化学')">化学 </span><span
            v-if="studentInfo.discipline.includes('生物')">生物 </span>
        <span v-if="studentInfo.discipline.includes('政治')">政治 </span><span
            v-if="studentInfo.discipline.includes('地理')">地理 </span></span>
      <span>所在中学：{{ studentInfo.schoolName }}</span>
      <span>毕业年份：{{ studentInfo.graduateYear }}</span>
      <span>高考成绩：{{ studentInfo.adminScore ? studentInfo.adminScore : 0 }}</span>
      <span>等位分：{{ equalScore }}</span>
      <span>位次：{{
          studentInfo.scores && studentInfo.scores.accumulate
              ? studentInfo.scores.accumulate
              : 0
        }}</span>
    </div>
    <div class="button">
      <div v-if="currentBatchName">
        <!--        <el-button type="primary" size="small">{{ currentBatchName }}</el-button>-->
        <el-tag>{{ currentBatchName }}</el-tag>
      </div>
      <div>
        <el-button type="warning" size="small" @click="systemAssess" v-if="draftId">评审</el-button>
        <el-button type="success" size="small" @click="showSetVolunteerTemplateDialog = true" v-if="draftId">设为志愿模板
        </el-button>
        <el-button type="primary" size="small" @click="saveVolunteerDraftPlan">保存</el-button>
      </div>
    </div>

    <volunteerTable ref="volunteerTable" v-if="volunteerMode" @addSpecialtyByOptionsClick="addSpecialtyByOptionsClick"
                    @addSpecialtyClick="addSpecialtyClick" @addCollegeClick="addCollegeClick"
                    @addSpecialtyOptionsClick="addSpecialtyOptionsClick"
                    @specialtyOptionsChanged="specialtyOptionsChanged"
                    @editSpecialtyByOptionsClick="editSpecialtyByOptionsClick" @exportTemplate="exportTemplate"
                    @func="showzyzy"
                    @editOptions="editOptions"
                    @collegeChanged="collegeChanged" @collegeAddSpecialty="collegeAddSpecialty"
                    @specialtyListSort="specialtyListSort"
                    @specialtyChanged="specialtyChanged" @getDraftPlanDetail="getDraftPlanDetail" :idOne="idOne"
                    :voPa="volunteerMode"
                    :id="draftId"
                    :planYear="planYear" :admissionYear="admissionYear"
                    :draftInfo="currentBatch.collegeList ? JSON.parse(JSON.stringify(currentBatch.collegeList)) : null"
                    :currentBatchName="currentBatchName"/>

    <!-- 添加院校 -->
    <el-dialog :title="'添加院校 ' + collegeParam.admitBatch" :visible.sync="addCollegeDialogShow" width="90%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="addCollegeDialogClosed">
      <div class="top">
        <span>学生姓名：{{ studentInfo.realName }}</span>
        <span>联系电话：{{ studentInfo.contactPhone }}</span>
        <span>性别：{{ studentInfo.sex === 0 ? "男" : "女" }}</span>
        <span v-if="studentInfo.disciplineType === 1">科别：理科</span>
        <span v-if="studentInfo.disciplineType === 2">科别：文科</span>
        <span v-if="studentInfo.disciplineType === 0 ||
        studentInfo.disciplineType === 3 ||
        studentInfo.disciplineType === 4
        ">科目：<span v-if="studentInfo.discipline.includes('物理')">物理 </span><span
            v-if="studentInfo.discipline.includes('历史')">历史 </span>
        <span v-if="studentInfo.discipline.includes('化学')">化学 </span><span
              v-if="studentInfo.discipline.includes('生物')">生物 </span>
        <span v-if="studentInfo.discipline.includes('政治')">政治 </span><span
              v-if="studentInfo.discipline.includes('地理')">地理 </span></span>
        <span>所在中学：{{ studentInfo.schoolName }}</span>
        <span>毕业年份：{{ studentInfo.graduateYear }}</span>
        <span>高考成绩：{{ studentInfo.adminScore ? studentInfo.adminScore : 0 }}</span>
        <span>等位分：{{ equalScore }}</span>
        <span>位次：{{
            studentInfo.scores
                ? studentInfo.scores.accumulate
                    ? studentInfo.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="collegeParam" class="demo-form-inline">
          <el-form-item label="院校省份:">
            <el-select v-model="collegeParam.collegeProvince" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称:">
            <el-input v-model="collegeParam.keyWord" placeholder="请输入院校名称或代码" size="small"
                      style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="院校标签:">
            <el-select v-model="collegeCharacter" placeholder="不限" multiple @change="changecollegeCharacter"
                       size="small"
                       style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="collegeParam.scoreMin" placeholder="最低分" size="small" style="width: 70px"></el-input>
            -
            <el-input v-model="collegeParam.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="collegeParam.accumulateMin" placeholder="最低位" size="small"
                      style="width: 70px"></el-input>
            -
            <el-input v-model="collegeParam.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="obtainCollegeList">搜索</el-button>
            <el-button size="small" type="primary" @click="confirmSelectCollege">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" ref="addCollegeTable" size="mini" :data="collegePlanList" max-height="460px" border
                  :row-key="getRowKeys" @select-all="selectAllCollege" @select="handleCollegeSelectionChanged"
                  @row-click="handleCollegeRowSelectionChanged"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" :reserve-selection="true" width="80"></el-table-column>
          <el-table-column prop="collegeCode" label="院校代码" width="100"></el-table-column>
          <el-table-column prop="collegeName" label="院校名称" min-width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="collegeTag" label="院校标签" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeTag ? scope.row.collegeTag : '/' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collegeCharacter" label="院校性质" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeCharacter ? scope.row.collegeCharacter : '/' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="72"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="80"></el-table-column>
        </el-table>
        <div style="margin-top:10px">已选择{{ selectedCollegeList.length }}个院校</div>
        <el-pagination style="margin-top:10px" background @current-change="handleChange"
                       :current-page.sync="collegeParam.current"
                       layout="prev, pager, next" :total="addCollegeTotal" :page-size="collegeParam.size">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 添加专业组志愿 -->
    <el-dialog :title="'添加专业组' + specialtyOptionsParam.admitBatch" :visible.sync="addSpecialtyOptionsDialogShow"
               width="95%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="addSpecialtyOptionsDialogClosed">
      <div class="top">
        <span>学生姓名：{{ studentInfo.realName }}</span>
        <span>联系电话：{{ studentInfo.contactPhone }}</span>
        <span>性别：{{ studentInfo.sex === 0 ? "男" : "女" }}</span>
        <span v-if="studentInfo.disciplineType === 1">科别：理科</span>
        <span v-if="studentInfo.disciplineType === 2">科别：文科</span>
        <span v-if="studentInfo.disciplineType === 0 ||
        studentInfo.disciplineType === 3 ||
        studentInfo.disciplineType === 4
        ">科目：<span v-if="studentInfo.discipline.includes('物理')">物理 </span><span
            v-if="studentInfo.discipline.includes('历史')">历史 </span>
        <span v-if="studentInfo.discipline.includes('化学')">化学 </span><span
              v-if="studentInfo.discipline.includes('生物')">生物 </span>
        <span v-if="studentInfo.discipline.includes('政治')">政治 </span><span
              v-if="studentInfo.discipline.includes('地理')">地理 </span></span>
        <span>所在中学：{{ studentInfo.schoolName }}</span>
        <span>毕业年份：{{ studentInfo.graduateYear }}</span>
        <span>高考成绩：{{ studentInfo.adminScore ? studentInfo.adminScore : 0 }}</span>
        <span>等位分：{{ equalScore }}</span>
        <span>位次：{{
            studentInfo.scores
                ? studentInfo.scores.accumulate
                    ? studentInfo.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="specialtyOptionsParam" class="demo-form-inline">
          <el-form-item label="院校省份:">
            <el-select v-model="specialtyOptionsParam.collegeProvince" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称:" v-if="addSpecialtyOptionsType === 0">
            <el-input v-model="specialtyOptionsParam.fuzzyCollegeName" placeholder="请输入院校名称" size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="专业组名称:">
            <el-input v-model="specialtyOptionsParam.professionalGroup" placeholder="请输入专业组名称或代码"
                      size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="包含专业:">
            <el-input v-model="specialtyOptionsParam.includeMajor" placeholder="请输入专业名称" size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="院校标签:">
            <el-select v-model="collegeCharacter1" placeholder="不限" multiple @change="changecollegeCharacter1"
                       size="small" style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="specialtyOptionsParam.scoreMin" placeholder="最低分" size="small"
                      style="width: 70px"></el-input>
            -
            <el-input v-model="specialtyOptionsParam.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="specialtyOptionsParam.accumulateMin" placeholder="最低位" size="small"
                      style="width: 70px">
            </el-input>
            -
            <el-input v-model="specialtyOptionsParam.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="obtainSpecialtyOptionsList">搜索</el-button>
            <el-button size="small" type="primary" @click="confirmSelectOptions">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table :stripe="true" ref="addOptionsTable" size="mini" :data="addSpecialtyOptionsDialogDataList"
                  max-height="460px" border
                  @select-all="selectAllSpecialtyOptions" :row-key="getRowKeys" @select="handleSelectionChangeOptions"
                  @row-click="handleRowSelectionChangeOptions"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" :reserve-selection="true" width="80"></el-table-column>
          <el-table-column prop="collegeCode" label="院校代码" width="100"></el-table-column>
          <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
          <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" min-width="150">
          </el-table-column>
          <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.specialtyName ? scope.row.specialtyName : "/" }}
            </template>
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="collegeTag" label="院校标签" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeTag ? scope.row.collegeTag : '/' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collegeCharacter" label="院校性质" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeCharacter ? scope.row.collegeCharacter : '/' }}</span>
            </template>
          </el-table-column>


          <!-- <el-table-column prop="admitBatch" label="录取批次" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column
            label="高考成绩"
            width="65"
          >
          <template>
              {{equalScore ? equalScore : 0}}
            </template></el-table-column> -->
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <!-- <el-table-column
            prop="scoreYearLast"
            :label="year - 2 + '最低分'"
            width="65"
          ></el-table-column> -->
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="72"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="80"></el-table-column>
        </el-table>
        <div style="margin-top:10px">已选择{{
            selectedSpecialtyOptionsList ? selectedSpecialtyOptionsList.length : '0'
          }}个专业组
        </div>
        <el-pagination style="margin-top:10px" background @current-change="handleChangezyz"
                       :current-page.sync="specialtyOptionsParam.current"
                       layout="prev, pager, next" :total="addOptionsTotal" :page-size="specialtyOptionsParam.size">
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 专业组志愿 -->
    <el-dialog title="专业组志愿" :visible.sync="editCollegeSpecialtyOptionsDialogShow" width="90%"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div class="el-dialog-div">
        <div style="margin-bottom: 10px; float: right">
          <el-button size="small" type="primary" @click="addOptions">添加专业组</el-button>
        </div>
        <div>
          <el-table :data="specialtyOptionsPlanList" border :stripe="true" size="mini" max-height="350px"
                    :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                    :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <!-- <el-table-column
              prop="collegeName"
              label="院校名称"
              :show-overflow-tooltip="true"
              min-width="120"
            ></el-table-column> -->
            <el-table-column prop="specialtyNames" label="专业组代码" width="100"></el-table-column>
            <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" min-width="150">
            </el-table-column>
            <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.specialtyName ? scope.row.specialtyName : "/" }}
              </template>
            </el-table-column>
            <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
              <template slot-scope="scope">
                <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
                <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
            <!-- <el-table-column
              prop="scoreYearLast"
              :label="year - 2 + '最低分'"
              width="65"
            ></el-table-column> -->
            <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="72"></el-table-column>
            <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                             width="72"></el-table-column>
            <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                             width="72"></el-table-column>
            <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planDiff" label="计划增减" width="80"></el-table-column>
            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-button style="font-size: 14px" type="text"
                           @click="deleteCollegeOptions(scope.$index, scope.row.sort)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 志愿专业 -->
    <el-dialog title="专业志愿" :visible.sync="editSpecialtyByOptionsDialogShow" width="90%"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <div class="el-dialog-div">
        <div style="margin-bottom: 10px; float: right">
          <el-button size="small" type="primary" @click="editSpecialtyByOptionsDialogAddClick">添加专业</el-button>
        </div>
        <div>
          <el-table :data="collegeOrOptionsSpecialtyList" border :stripe="true" size="mini" max-height="350px"
                    :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                    :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true" width="120">
            </el-table-column>
            <el-table-column prop="specialtyNames" label="专业组代码" width="100"
                             v-if="volunteerMode === 3"></el-table-column>
            <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" width="150"
                             v-if="volunteerMode === 3"></el-table-column>
            <el-table-column prop="specialtyCode" label="专业代码" width="100"></el-table-column>
            <el-table-column prop="specialtyName" label="专业名名称" :show-overflow-tooltip="true" min-width="180">
            </el-table-column>
            <el-table-column label="选考科目要求" min-width="150" show-overflow-tooltip>0
              <template slot-scope="scope">
                <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
                <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
            <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="72"></el-table-column>
            <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                             width="72"></el-table-column>
            <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                             width="72"></el-table-column>
            <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
            <el-table-column prop="planDiff" label="计划增减" width="80"></el-table-column>
            <el-table-column label="排序" width="80" v-if="volunteerMode !== 2">
              <template slot-scope="scope">
                <input size="small" v-model="scope.row.psort"
                       @blur="specialtyPlanDialogSortChangedByInput(scope.row, scope.$index)"
                       style="width: 26px;text-align:center;padding-left:10px;padding-right:10px"/>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button style="font-size: 14px" type="text"
                           @click="specialtyPlanDialogDeleteSpecialty(scope.$index, scope.row.psort)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <!-- 添加专业 -->
    <el-dialog :title="'添加专业' + specialtyParam.admitBatch" :visible.sync="addSpecialtyDialogShow" width="90%"
               :close-on-click-modal="false" :close-on-press-escape="false" @closed="addSpecialtyDialogClosed">
      <div class="top">
        <span>学生姓名：{{ studentInfo.realName }}</span>
        <span>联系电话：{{ studentInfo.contactPhone }}</span>
        <span>性别：{{ studentInfo.sex === 0 ? "男" : "女" }}</span>
        <span v-if="studentInfo.disciplineType === 1">科别：理科</span>
        <span v-if="studentInfo.disciplineType === 2">科别：文科</span>
        <span v-if="studentInfo.disciplineType === 0 ||
        studentInfo.disciplineType === 3 ||
        studentInfo.disciplineType === 4
        ">科目：<span v-if="studentInfo.discipline.includes('物理')">物理 </span><span
            v-if="studentInfo.discipline.includes('历史')">历史 </span>
        <span v-if="studentInfo.discipline.includes('化学')">化学 </span><span
              v-if="studentInfo.discipline.includes('生物')">生物 </span>
        <span v-if="studentInfo.discipline.includes('政治')">政治 </span><span
              v-if="studentInfo.discipline.includes('地理')">地理 </span></span>
        <span>所在中学：{{ studentInfo.schoolName }}</span>
        <span>毕业年份：{{ studentInfo.graduateYear }}</span>
        <span>高考成绩：{{ studentInfo.adminScore ? studentInfo.adminScore : 0 }}</span>
        <span>等位分：{{ equalScore }}</span>
        <span>位次：{{
            studentInfo.scores
                ? studentInfo.scores.accumulate
                    ? studentInfo.scores.accumulate
                    : 0
                : 0
          }}</span>
      </div>
      <div class="el-dialog-div">
        <el-form :inline="true" :model="specialtyParam" class="demo-form-inline">
          <el-form-item label="院校省份:">
            <el-select v-model="specialtyParam.collegeProvince" placeholder="不限" size="small" clearable
                       style="width: 100px; margin-right: 10px">
              <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称:" v-if="volunteerMode !== 3 && specialtyAddType !== 2">
            <el-input v-model="specialtyParam.universityName" placeholder="请输入院校名称或代码" size="small"
                      style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="专业组名称:" v-if="volunteerMode === 3 && specialtyAddType !== 2">
            <el-input v-model="specialtyParam.professionalGroup" placeholder="请输入专业组名称或代码" size="small"
                      style="width: 180px"></el-input>
          </el-form-item>
          <el-form-item label="院校标签:">
            <el-select v-model="collegeCharacter" placeholder="不限" multiple @change="changecollegeCharacter2"
                       size="small"
                       style="width: 220px; margin-right: 10px">
              <el-option v-for="item in optionsCharacter" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业名称:">
            <el-input v-model="specialtyParam.keyWord" placeholder="请输入专业名称或代码" size="small"
                      style="width: 180px">
            </el-input>
          </el-form-item>
          <el-form-item label="分段:">
            <el-input v-model="specialtyParam.scoreMin" placeholder="最低分" size="small"
                      style="width: 70px"></el-input>
            -
            <el-input v-model="specialtyParam.scoreMax" placeholder="最高分" size="small"
                      style="width: 70px; margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item label="位次:">
            <el-input v-model="specialtyParam.accumulateMin" placeholder="最低位" size="small" style="width: 70px;">
            </el-input>
            -
            <el-input v-model="specialtyParam.accumulateMax" placeholder="最高位" size="small"
                      style="width: 70px;margin-right: 10px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="selectSpecialtyList">搜索</el-button>
            <el-button size="small" type="primary" @click="confirmSelectSpecialty">确定</el-button>
          </el-form-item>
        </el-form>
        <el-table ref="addSpecialtyTable" :stripe="true" size="mini" :data="addSpecialtyDialogDataList"
                  :row-key="getRowKeys1"
                  border
                  max-height="460px" @select-all="selectAllSpecialty" @select="handleSpecialtySelectionChanged"
                  @row-click="handleSpecialtyRowSelectionChanged"
                  :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                  :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
          <el-table-column type="selection" width="80" :reserve-selection="true"></el-table-column>
          <el-table-column prop="collegeCode" label="院校代码" width="80" v-if="volunteerMode !== 3"></el-table-column>
          <el-table-column prop="collegeName" label="院校名称" :show-overflow-tooltip="true"
                           width="150"></el-table-column>
          <el-table-column prop="collegeCity" label="所在城市" width="80"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="collegeTag" label="院校标签" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeTag ? scope.row.collegeTag : '/' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="collegeCharacter" label="院校性质" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.collegeCharacter ? scope.row.collegeCharacter : '/' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="specialtyNames" label="专业组代码" width="100"
                           v-if="volunteerMode === 3"></el-table-column>
          <el-table-column prop="specialtyOptions" :show-overflow-tooltip="true" label="专业组名称" width="150"
                           v-if="volunteerMode === 3"></el-table-column>
          <el-table-column label="包含专业" min-width="120" show-overflow-tooltip v-if="volunteerMode === 3">
            <template slot-scope="scope">
              {{ scope.row.specialtyName1 ? scope.row.specialtyName1 : "/" }}
            </template>
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip v-if="volunteerMode === 3">
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="specialtyCode" label="专业代码" width="100"></el-table-column>
          <el-table-column prop="specialtyName" label="专业名称" min-width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="选考科目要求" width="150" show-overflow-tooltip v-if="volunteerMode === 2">
            <template slot-scope="scope">
              <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
              <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="admitBatch" label="录取批次" :show-overflow-tooltip="true" width="80"></el-table-column> -->
          <el-table-column prop="scoreYearThis" :label="admissionYear + '最低分'" width="65"></el-table-column>
          <!-- <el-table-column
            prop="scoreYearLast"
            :label="year - 2 + '最低分'"
            width="65"
          ></el-table-column> -->
          <el-table-column prop="accumulateYearThis" :label="admissionYear + '最低位次'" width="72"></el-table-column>
          <el-table-column prop="accumulateYearLast" :label="admissionYear - 1 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="accumulateYearOther" :label="admissionYear - 2 + '最低位次'"
                           width="72"></el-table-column>
          <el-table-column prop="planYearLast" :label="planYear - 1 + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planYearThis" :label="planYear + '计划数'" width="65"></el-table-column>
          <el-table-column prop="planDiff" label="计划增减" width="80"></el-table-column>
        </el-table>
        <div style="margin-top:10px">已选择{{ selectedSpecialtyList.length }}个专业</div>
        <el-pagination style="margin-top:10px" background @current-change="handleChangezy"
                       :current-page.sync="specialtyParam.current" layout="prev, pager, next" :total="addSpecialtyTotal"
                       :page-size="specialtyParam.size">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
        title="设为志愿模板"
        :visible.sync="showSetVolunteerTemplateDialog"
        width="430px"
        @open="openDialog"
    >
      <el-form :model="temform">
        <el-form-item label="模板名称:" label-width="100px">
          <el-input
              v-model="temform.templateName"
              size="small"
              style="width: 260px"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板备注:" label-width="100px">
          <el-input
              v-model="temform.templateRemarks"
              type="textarea"
              size="small"
              :rows="5"
              style="width: 260px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSetVolunteerTemplateDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="setVolunteerTemplateDialogConfirm" size="small"
        >确 定</el-button
        >
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "@/util/request";
import {
  getDraftPlanDetail,
  getProvincePage,
  getStudentDetail,
  previewAdmitDraft,
  savedraft,
  selectCollegeList,
  selectCollegeOptionsList,
  selectCollegeSpecialtyList,
  selectEqualScore,
  selectSpecialtyOptionsList,
  selectSpecialtyOptionsListV2,
  setTemplate,
  systemAssess,
} from "@/api/serviceManagement.js";
import {getProvinceList} from "@/api/index.js";
import volunteerTable from "./components/volunteerTable.vue";

export default {
  components: {
    volunteerTable,
  },
  data() {
    return {
      addCollegeTotal: 0,
      addSpecialtyTotal: 0,
      addOptionsTotal: 0,
      temform: {},
      //专业组筛选条件
      specialtyOptionsParam: {
        collegeName: "",
        fuzzyCollegeName: "",
        professionalGroup: "",
        includeMajor: "",
        size: 200,
        current: 1
      },
      collegeCharacter1: [],
      //高考成绩等位分
      equalScore: 0,
      //选择院校特性
      collegeCharacter: [],
      //院校筛选条件
      collegeParam: {size: 200, current: 1, collegeCharacter: ""},
      //专业筛选条件
      specialtyParam: {size: 200, current: 1},
      //当前批次名称
      currentBatchName: "",
      //志愿模式 1.院校模式 2.专业模式 3.专业组模式
      volunteerMode: null,
      //添加院校弹框显示与否
      addCollegeDialogShow: false,
      //专业组编辑专业弹框显示与否
      editSpecialtyByOptionsDialogShow: false,
      //添加专业弹框显示与否
      addSpecialtyDialogShow: false,
      //添加专业组弹框显示与否
      addSpecialtyOptionsDialogShow: false,
      //添加专业组弹框数据源
      addSpecialtyOptionsDialogDataList: [],
      //当前草稿信息
      draftInfo: {},
      //确认院校志愿
      gridData: [],
      //所有院校志愿
      collegePlanList: [],
      //院校或专业组 专业列表
      collegeOrOptionsSpecialtyList: [],
      //添加专业弹框数据源
      addSpecialtyDialogDataList: [],
      //院校特性
      optionsCharacter: [
        {label: "211", value: "1"},
        {label: "985", value: "2"},
        {label: "双一流", value: "3"},
        {label: "国重点", value: "4"},
        {label: "省重点", value: "5"},
        {label: "保研资格", value: "6"}
      ],
      //学生信息
      studentInfo: {},
      //批次列表
      batchList: [],
      //方案记录
      options: [],
      value: "", //选中方案记录
      options1: [], //高校省份
      //草稿id
      draftId: "",
      //最近招生计划年份
      planYear: 0,
      //最近录取数据年份
      admissionYear: 0,
      //选择的学校
      selectedCollegeList: [],
      //选择的专业组
      selectedSpecialtyOptionsList: [],
      //选择的专业
      selectedSpecialtyList: [],
      //一对一服务id
      idOne: "",
      //判断添加专业位置 1直接添加 2通过学校或专业组添加
      specialtyAddType: 0,
      //志愿详情
      data: {},
      planRemarkList: [],
      //专业组1列表里添加 0外部添加
      addSpecialtyOptionsType: 0,
      //编辑院校专业组弹框显示与否
      editCollegeSpecialtyOptionsDialogShow: false,
      //专业组方案数据源
      specialtyOptionsPlanList: [],
      id: "",
      batch: "",
      //当前批次
      currentBatch: {},
      draftCollegeList: [],
      //新选择的专业组
      newSelectSpecialtyOptionsList: [],
      oldSelectSpecialtyOptionsList: [],
      //院校原有的专业组
      originalCollegeSpecialOptionsList: [],
      autoSelectSpecialtyIndex: 0,
      //设为志愿模板弹框显示与否
      showSetVolunteerTemplateDialog: false,
      //院校原有专业
      originalCollegeOrOptionsSpecialtyList: []
    };
  },
  watch: {
    $route(val) {
      if (val.path === "/addVolunteerPlan") {
        this.collegeParam = {size: 200, current: 1, collegeCharacter: ""};
        this.specialtyParam = {size: 200, current: 1};
        this.draftInfo = {};

        this.initYear();
        this.id = this.$route.query.id;
        this.idOne = this.$route.query.idOne;
        this.draftId = this.$route.query.draftId;
        this.draftInfo.draftId = this.$route.query.draftId;
        this.currentBatchName = this.$route.query.batch;
        if (this.$route.query.voPa) {
          this.volunteerMode = this.$route.query.voPa - 0;
        }
        this.draftInfo.remark = this.$route.query.remark;
        this.draftInfo.planName = this.$route.query.planName;
        this.getProvinceList();
        if (this.id) {
          this.getStudentDetail(this.id);
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", (e) => {
    });
  },
  mounted() {
    window.addEventListener("beforeunload", function (event) {
      // 在这里执行你的操作，比如保存数据或弹出确认提示框
      // 请注意，你不能在此事件中使用异步操作，因为页面将在此事件完成后立即关闭

      // 如果想要显示一个确认提示框，可以返回一个提示文本
      const confirmationMessage = '请确认是否保存志愿方案？';

      event.returnValue = confirmationMessage;
      return confirmationMessage;
    });
    this.initYear();
    this.id = this.$route.query.id;
    this.idOne = this.$route.query.idOne;
    this.draftId = this.$route.query.draftId;
    this.draftInfo.draftId = this.draftId
    this.currentBatchName = this.$route.query.batch;
    if (this.$route.query.voPa) {
      this.volunteerMode = this.$route.query.voPa - 0;
    }
    this.draftInfo.remark = this.$route.query.remark;
    this.draftInfo.planName = this.$route.query.planName;
    this.getProvinceList();
    if (this.id) {
      this.getStudentDetail(this.id);
    }
  },
  methods: {
    openDialog() {
      this.temform = {};
    },
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },
    // 志愿草稿打印
    exportTemplate(e) {
      let type = e.type;
      let title = "";
      if (type === 1) {
        title = "学校";
      } else if (type === 2) {
        title = "专业";
      } else {
        title = "专业组";
      }
      let data = {
        type: type,
        includeMoreInfo: e.includeMoreInfo,
        admitBatch: this.currentBatchName,
        draftId: this.draftId,
        source: 2,
        fraction: 1,
        voPa: this.volunteerMode,
      };

      let fileName = this.studentInfo.realName + this.currentBatchName + title + "草稿志愿.xlsx";
      if (e.includeMoreInfo === 1) {
        fileName = this.studentInfo.realName + this.currentBatchName + title + "草稿志愿(含更多信息).xlsx";
      }

      axios({
        method: "post",
        url: "/com/had-login/aspiration/aspiration-plan/vertical/exportTemplate",
        data: data,
        responseType: "blob",
      }).then((res) => {
        const elink = document.createElement("a");
        elink.download = fileName; //定义表格名称，后缀是文件格式
        elink.style.display = "none";
        const blob = new Blob([res], {
          type: "application/vnd.ms-excel",
        });
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      })
          .catch((err) => {
            console.log(err);
          });
    },
    /**
     * 专业志愿弹框 输入框顺序改变
     * @param index
     */
    specialtyPlanDialogSortChangedByInput(row, index) {
      let oldSort = index + 1;
      let data = {...row};
      let newSort = data.psort
      console.log(`专业志愿弹框输入框改变顺序 原序号：${oldSort}, 新序号：${newSort}`)
      if (Math.floor(newSort).toString() !== newSort) {
        this.collegeOrOptionsSpecialtyList[index].psort = oldSort;
        this.$message.error("排序序号输入错误，请重新输入")
        return;
      }
      if (newSort < 1) {
        newSort = 1;
      }
      if (newSort > this.collegeOrOptionsSpecialtyList.length) {
        newSort = this.collegeOrOptionsSpecialtyList.length;
      }

      if (newSort < oldSort) {
        // 大于等于newSort 小于oldSort的sort+1
        this.collegeOrOptionsSpecialtyList.forEach(item => {
          let tempSort = parseInt(item.psort);
          if (item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
              item.psort >= newSort &&
              item.psort < oldSort) {
            item.psort = tempSort + 1;
          }

          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        })
      } else if (newSort > oldSort) {
        //小于等于newSort 大于oldSort 的sort - 1
        this.collegeOrOptionsSpecialtyList.forEach(item => {
          let tempSort = parseInt(item.psort);
          if (item.collegeName + item.specialtyName !== data.collegeName + data.specialtyName &&
              item.psort > oldSort &&
              item.psort <= newSort) {
            item.psort = tempSort - 1;
          }

          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        })
      } else {
        this.collegeOrOptionsSpecialtyList.forEach(item => {
          if (item.collegeName + item.specialtyName === data.collegeName + data.specialtyName) {
            item.psort = newSort;
          }
        })
      }

      this.collegeOrOptionsSpecialtyList.sort((a, b) => {
        return a.psort - b.psort
      })

      let currentSpecialty = this.collegeOrOptionsSpecialtyList[0];
      this.specialtyPlanList = [];
      this.collegePlanList.forEach((college) => {
        if (this.volunteerMode === 1) {
          //院校模式
          if (college.collgeName === currentSpecialty.collegeName) {
            college.specialtyList = [...this.collegeOrOptionsSpecialtyList] || []
          }
        } else if (this.volunteerMode === 3) {
          //专业组
          if (college.optionsList && college.optionsList.length > 0) {
            college.optionsList.forEach(options => {
              if (options.collegeName + options.specialtyOptions === currentSpecialty.collegeName + currentSpecialty.specialtyOptions) {
                options.specialtyList = [...this.collegeOrOptionsSpecialtyList] || []
              }
            })
          }
        }
      });

      this.$emit("collegeChanged", this.collegePlanList);

    },
    getRowKeys(row) {
      return row.specialtyUuid;
    },
    getRowKeys1(row) {
      return row.specialtyUuid;
    },
    // 删除院校专业组
    deleteCollegeOptions(index, sort) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.specialtyOptionsPlanList && this.specialtyOptionsPlanList.length > 0) {
          this.batchList.forEach(batch => {
            if (batch.batch === this.currentBatchName) {
              batch.collegeList.forEach(college => {
                if (this.specialtyOptionsPlanList[0].collegeName === college.collegeName) {
                  this.specialtyOptionsPlanList.splice(index, 1);

                  if (this.specialtyOptionsPlanList && this.specialtyOptionsPlanList.length > 0) {
                    college.optionsList = [...this.specialtyOptionsPlanList] || []
                  }
                }
              });

              batch.collegeList.forEach(college => {
                if (college.optionsList) {
                  college.optionsList.forEach(options => {
                    if (options.sort > sort) {
                      options.sort = options.sort - 1;
                    }
                  })
                }
              })

              this.currentBatch = {...batch};
              this.$refs.volunteerTable.refreshData(
                  this.currentBatch.collegeList
              );
            }
          })
        }

      });
    },
    // 专业组数据改变
    specialtyOptionsChanged(optionsList) {
      let collegeOptionsMap = new Map();

      optionsList.forEach(options => {
        if (!collegeOptionsMap.has(options.collegeName)) {
          collegeOptionsMap.set(options.collegeName, [])
        }
        collegeOptionsMap.get(options.collegeName).push(options)
      });

      this.batchList.forEach((item) => {
        if (item.batch === this.currentBatchName) {
          item.collegeList.forEach((college) => {
            let collegeOptionList = collegeOptionsMap.get(college.collegeName) || [];
            collegeOptionList.forEach(options => {
              if (options.specialtyList && options.specialtyList.length > 0) {
                options.specialtyList.forEach((specialty) => {
                  specialty.sort = options.sort;
                });
              }
            });
            college.optionsList = [...collegeOptionList];
          });

          this.currentBatch = {...item};
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
    },
    // 专业组编辑专业
    editSpecialtyByOptionsClick(data) {
      this.specialtyParam.collegeCode = data.collegeCode;
      this.specialtyParam.collegeName = data.collegeName;
      this.specialtyParam.specialtyOptions = data.specialtyOptions;
      if (data.specialtyList) {
        if (data.specialtyList.length === 1 && !data.specialtyList[0].specialtyName) {
          //填充的空专业
          this.collegeOrOptionsSpecialtyList = [];
        }
        this.collegeOrOptionsSpecialtyList = data.specialtyList;
      } else {
        this.collegeOrOptionsSpecialtyList = [];
      }
      this.editSpecialtyByOptionsDialogShow = true;
    },
    //从专业组志愿添加专业
    addSpecialtyByOptionsClick(data) {
      console.log("添加专业");
      this.specialtyParam.collegeCode = data.collegeCode;
      this.specialtyParam.collegeName = data.collegeName;
      this.specialtyParam.specialtyOptions = data.specialtyOptions;
      this.specialtyParam.professionalGroup = null;

      if (data.specialtyList) {
        if (data.specialtyList.length === 1 && !data.specialtyList[0].specialtyName) {
          //填充的空专业
          this.collegeOrOptionsSpecialtyList = [];
        }
        this.collegeOrOptionsSpecialtyList = data.specialtyList;
      } else {
        this.collegeOrOptionsSpecialtyList = [];
      }
      this.selectedSpecialtyList = this.collegeOrOptionsSpecialtyList ? [...this.collegeOrOptionsSpecialtyList] : [];

      console.log(this.selectedSpecialtyList, "当前已选专业");
      this.selectSpecialtyList();
      this.specialtyAddType = 2;
    },
    /**
     * 保存志愿草稿方案
     */
    saveVolunteerDraftPlan() {
      this.draftInfo.admitBatch = this.currentBatchName;
      this.draftInfo.year = this.studentInfo.graduateYear;
      this.draftInfo.studentId = this.studentInfo.studentId;
      this.draftInfo.oneId = this.idOne;
      this.draftInfo.provinceId = this.studentInfo.province;
      this.draftInfo.province = this.studentInfo.examProvince;
      this.draftInfo.batchs = this.batchList;
      let saveDraftInfo = {...this.draftInfo};
      savedraft(saveDraftInfo).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "保存成功，正在刷新方案",
            type: "success",
          });
          if (this.draftId) {
            this.getDraftPlanDetail(this.draftId)
          } else {
            this.$router.push({
              path: "/addVolunteerPlan",
              query: {
                id: this.id,
                idOne: this.idOne,
                draftId: res.data,
                batch: this.currentBatchName,
              },
            })
          }
        } else {
          this.$message.error(res.msg)
        }
      });
    },

    setVolunteerTemplateDialogConfirm() {
      if (!this.temform.templateName) {
        this.$message.error("请输入模板名称");
        return;
      }
      setTemplate({
        draftId: this.draftId,
        isTemplate: 1,
        ...this.temform
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success("设置成功");
          this.showSetVolunteerTemplateDialog = false
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * 专业志愿弹框 删除专业
     * @param index
     * @param psort
     */
    specialtyPlanDialogDeleteSpecialty(index, psort) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.volunteerMode === 1) {
          if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
            this.batchList.forEach((item) => {
              if (item.batch === this.currentBatchName) {
                item.collegeList.forEach(college => {
                  if (
                      this.collegeOrOptionsSpecialtyList[0].collegeName === college.collegeName &&
                      this.collegeOrOptionsSpecialtyList[0].specialtyOptions ===
                      college.specialtyOptions
                  ) {
                    this.collegeOrOptionsSpecialtyList.splice(index, 1);
                    this.collegeOrOptionsSpecialtyList.forEach((item2, i) => {
                      item2.psort = i + 1;
                    });
                    if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
                      college.specialtyList = this.collegeOrOptionsSpecialtyList;
                    } else {
                      college.specialtyList = [
                        {
                          collegeCode: college.collegeCode,
                          collegeName: college.collegeName,
                          specialtyOptions: "",
                          admitBatch: college.admitBatch,
                          requiredType: college.requiredType,
                          specialtyUuid: college.collegeName,
                          sort: college.sort,
                          requiredDiscipline: college.requiredDiscipline,
                          scoreYearThis2: college.scoreYearThis,
                          accumulateYearThis2: college.accumulateYearThis,
                          accumulateYearLast2: college.accumulateYearLast,
                          accumulateYearOther2: college.accumulateYearOther,
                          planYearLast2: college.planYearLast,
                          planYearThis2: college.planYearThis,
                          planDiff2: college.planDiff,
                        },
                      ];
                    }
                  }
                });
              }
            });
          }
        } else if (this.volunteerMode === 2) {
          if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
            this.batchList.forEach((item) => {
              if (item.batch === this.currentBatchName) {
                item.collegeList.forEach(college => {
                  if (
                      this.collegeOrOptionsSpecialtyList[0].collegeName === college.collegeName &&
                      this.collegeOrOptionsSpecialtyList[0].specialtyOptions ===
                      college.specialtyOptions
                  ) {
                    this.collegeOrOptionsSpecialtyList.splice(index, 1);
                    if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
                      college.specialtyList = this.collegeOrOptionsSpecialtyList || [];
                    } else {
                      college.specialtyList = [
                        {
                          collegeCode: college.collegeCode,
                          collegeName: college.collegeName,
                          specialtyOptions: "",
                          admitBatch: college.admitBatch,
                          requiredType: college.requiredType,
                          specialtyUuid: college.collegeName,
                          sort: college.sort,
                          requiredDiscipline: college.requiredDiscipline,
                          scoreYearThis2: college.scoreYearThis,
                          accumulateYearThis2: college.accumulateYearThis,
                          accumulateYearLast2: college.accumulateYearLast,
                          accumulateYearOther2: college.accumulateYearOther,
                          planYearLast2: college.planYearLast,
                          planYearThis2: college.planYearThis,
                          planDiff2: college.planDiff,
                        },
                      ];
                    }
                  }
                });

                item.collegeList.forEach(college => {
                  if (college.specialtyList) {
                    college.specialtyList.forEach(specialty => {
                      if (specialty.psort > psort) {
                        specialty.psort = specialty.psort - 1;
                      }
                    });
                  }
                });
              }
            });
          }
        } else if (this.volunteerMode === 3) {
          if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
            this.batchList.forEach((item) => {
              if (item.batch === this.currentBatchName) {
                item.collegeList.forEach(college => {
                  if (this.collegeOrOptionsSpecialtyList[0].collegeName === college.collegeName) {
                    college.optionsList.forEach((options) => {
                      if (
                          this.collegeOrOptionsSpecialtyList[0].collegeName ===
                          options.collegeName &&
                          this.collegeOrOptionsSpecialtyList[0].specialtyOptions ===
                          options.specialtyOptions
                      ) {
                        this.collegeOrOptionsSpecialtyList.splice(index, 1);
                        this.collegeOrOptionsSpecialtyList.forEach((item2, i) => {
                          item2.psort = i + 1;
                        });
                        if (this.collegeOrOptionsSpecialtyList && this.collegeOrOptionsSpecialtyList.length > 0) {
                          options.specialtyList = this.collegeOrOptionsSpecialtyList;
                        } else {
                          options.specialtyList = [
                            {
                              collegeCode: options.collegeCode,
                              collegeName: options.collegeName,
                              specialtyNames: options.specialtyNames,
                              specialtyOptions: options.specialtyOptions,
                              admitBatch: options.admitBatch,
                              requiredType: options.requiredType,
                              specialtyUuid: options.specialtyOptions,
                              sort: options.sort,
                              requiredDiscipline: options.requiredDiscipline,
                              scoreYearThis2: options.scoreYearThis,
                              accumulateYearThis2: options.accumulateYearThis,
                              accumulateYearLast2: options.accumulateYearLast,
                              accumulateYearOther2: options.accumulateYearOther,
                              planYearLast2: options.planYearLast,
                              planYearThis2: options.planYearThis,
                              planDiff2: options.planDiff,
                            },
                          ];
                        }
                      }
                    });
                  }
                });
              }
            });
          }
        }
        this.batchList.forEach((item) => {
          if (item.batch === this.currentBatchName) {
            this.currentBatch = {...item};
            this.$refs.volunteerTable.refreshData(
                this.currentBatch.collegeList
            );
          }
        });
      });
    },
    // 专业数据改变
    specialtyChanged(specialtyList) {
      console.log("专业数据改变")
      let collegeSpecialtyMap = new Map();
      specialtyList.forEach((specialty) => {
        if (!collegeSpecialtyMap.has(specialty.collegeName)) {
          collegeSpecialtyMap.set(specialty.collegeName, []);
        }
        collegeSpecialtyMap.get(specialty.collegeName).push(specialty);
      });

      this.batchList.forEach((item) => {
        if (item.batch === this.currentBatchName) {
          item.collegeList.forEach((college) => {
            college.specialtyList = [...collegeSpecialtyMap.get(college.collegeName) || []];
          });
          this.currentBatch = {...item};
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
    },
    specialtyListSort(allSpecialtyData) {
      this.batchList.forEach((item) => {
        if (item.batch === this.currentBatchName) {
          item.collegeList.forEach((college) => {
            college.specialtyList = [];
            if (allSpecialtyData && allSpecialtyData.length > 0) {
              allSpecialtyData.forEach((specialty) => {
                if (
                    specialty.collegeName === college.collegeName &&
                    specialty.specialtyOptions === college.specialtyOptions
                ) {
                  college.specialtyList.push(specialty);
                }
              });
            }
          });
          this.currentBatch = {...item};
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
    },
    // 添加专业志愿 直接添加专业
    addSpecialtyClick() {
      this.specialtyAddType = 1;
      if (this.volunteerMode !== 3) {
        this.specialtyParam.collegeCode = null;
        this.specialtyParam.collegeName = null;
        this.specialtyParam.specialtyOptions = null;
        this.selectedSpecialtyList = [];
        this.batchList.forEach((item) => {
          if (item.batch === this.currentBatchName) {
            if (item.collegeList && item.collegeList.length > 0) {
              item.collegeList.forEach(college => {
                if (
                    college.specialtyList &&
                    college.specialtyList.length > 0
                ) {
                  this.selectedSpecialtyList = [...this.selectedSpecialtyList, ...college.specialtyList];
                }
              });
            }
          }
        });
      } else {
        //专业组
        this.specialtyParam.collegeCode = null;
        this.specialtyParam.collegeName = null;
        this.specialtyParam.specialtyOptions = null;
        this.selectedSpecialtyList = [];
        this.batchList.forEach((item) => {
          if (item.batch === this.currentBatchName) {
            if (item.collegeList && item.collegeList.length > 0) {
              item.collegeList.forEach(college => {
                if (college.optionsList && college.optionsList.length > 0) {
                  college.optionsList.forEach((item) => {
                    if (item.specialtyList && item.specialtyList.length > 0) {
                      this.selectedSpecialtyList = [...this.selectedSpecialtyList, ...item.specialtyList];
                    }
                  });
                }
              });
            }
          }
        });
      }
      //显示弹框  加载数据
      this.addSpecialtyDialogShow = true;
    },
    // 添加专业组志愿
    addSpecialtyOptionsClick(res) {
      console.log(res, "添加专业组点击")
      this.addSpecialtyOptionsType = res.type;
      this.selectedSpecialtyOptionsList = [];
      this.oldSelectSpecialtyOptionsList = []
      this.originalCollegeSpecialOptionsList = []

      this.batchList.forEach((item) => {
        this.specialtyOptionsParam.collegeName = null;
        if (item.batch === this.currentBatchName) {
          if (item.collegeList && item.collegeList.length > 0) {
            item.collegeList.forEach((college) => {
              if (college.optionsList && college.optionsList.length > 0) {
                if (this.addSpecialtyOptionsType === 0) {
                  this.selectedSpecialtyOptionsList = [...this.selectedSpecialtyOptionsList, ...college.optionsList];
                  this.oldSelectSpecialtyOptionsList = [...this.selectedSpecialtyOptionsList];
                }
                if (this.addSpecialtyOptionsType === 1) {
                  this.selectedSpecialtyOptionsList = res.data.optionsList || [];
                  this.originalCollegeSpecialOptionsList = [...this.selectedSpecialtyOptionsList];
                  this.oldSelectSpecialtyOptionsList = [...this.oldSelectSpecialtyOptionsList, ...college.optionsList];
                }
              }
            });
          }
        }
      });

      this.addSpecialtyOptionsDialogShow = true;
      if (this.addSpecialtyOptionsType === 1) {
        this.specialtyOptionsParam.collegeName = res.data.collegeName;
      }
      this.specialtyOptionsParam.isOptions = 1;
      this.specialtyOptionsParam.isMinority = this.studentInfo.isMinority;
      this.specialtyOptionsParam.isNationalSpecial = this.studentInfo.isNationalSpecial;
      this.specialtyOptionsParam.isLocalSpecial = this.studentInfo.isLocalSpecial;
      this.specialtyOptionsParam.isUniversitySpecial = this.studentInfo.isUniversitySpecial;
      this.specialtyOptionsParam.colorWeakness = this.studentInfo.colorWeakness;
      if (res.type === 1) {
        this.obtainSpecialtyOptionsList();
      }
      this.selectEqualScore();
    },
    addOptions() {
      this.selectedSpecialtyOptionsList = this.specialtyOptionsPlanList
          ? [...this.specialtyOptionsPlanList]
          : [];
      this.addSpecialtyOptionsType = 1;
      this.addSpecialtyOptionsDialogShow = true;
      this.oldSelectSpecialtyOptionsList = [];
      let arr = [...this.selectedSpecialtyOptionsList];
      arr.forEach((item) => {
        this.oldSelectSpecialtyOptionsList.push(item.specialtyOptions);
      });
      this.specialtyOptionsParam.isOptions = 1;
      this.obtainSpecialtyOptionsList();
      this.selectEqualScore();
    },
    // 关闭选择学校
    addCollegeDialogClosed() {
      this.collegePlanList = []
      this.collegeParam.collegeProvinceId = "";
      this.collegeParam.scoreMax = "";
      this.collegeParam.scoreMin = "";
      this.collegeCharacter = [];
      this.collegeParam.accumulateMax = "";
      this.collegeParam.accumulateMin = "";
      this.collegeParam.keyWord = "";
      this.collegeParam.collegeCharacter = "";
      this.collegeParam = {...this.collegeParam};
    },
    // 关闭选择专业组
    addSpecialtyOptionsDialogClosed() {
      this.addSpecialtyOptionsDialogDataList = []
      this.specialtyOptionsParam.collegeProvinceId = "";
      this.specialtyOptionsParam.collegeName = "";
      this.specialtyOptionsParam.fuzzyCollegeName = "";
      this.specialtyOptionsParam.includeMajor = "";
      this.specialtyOptionsParam.scoreMax = "";
      this.specialtyOptionsParam.scoreMin = "";
      this.collegeCharacter1 = [];
      this.specialtyOptionsParam.accumulateMax = "";
      this.specialtyOptionsParam.accumulateMin = "";
      this.specialtyOptionsParam.keyWord = "";
      this.specialtyOptionsParam.collegeCharacter = "";
      this.specialtyOptionsParam = {...this.specialtyOptionsParam};
    },
    // 关闭选择专业
    addSpecialtyDialogClosed() {
      this.specialtyParam.scoreMax = "";
      this.specialtyParam.scoreMin = "";
      this.specialtyParam.accumulateMax = "";
      this.specialtyParam.accumulateMin = "";
      this.specialtyParam.majorName1 = "";
      this.specialtyParam.specialtys = [];
      this.specialtyParam.universityName = "";
      this.specialtyParam.professionalGroup = "";
      this.specialtyParam.keyWord = ""
      this.specialtyParam.specialtyOptions = "";
      this.specialtyParam = {...this.specialtyParam};
      this.addSpecialtyDialogDataList = []
    },
    // 院校特性赛选改变
    changecollegeCharacter(val) {
      console.log(val, "val");
      this.collegeParam.collegeCharacter = val.join(",");
    },
    changecollegeCharacter2(val) {
      console.log(val, "val");
      this.specialtyParam.collegeCharacter = val.join(",");
    },
    changecollegeCharacter1(val) {
      console.log(val, "val");
      this.specialtyOptionsParam.collegeCharacter = val.join(",");
    },
    // 编辑专业
    showzyzy(data) {
      this.specialtyParam.collegeCode = data.collegeCode;
      this.specialtyParam.collegeName = data.collegeName;
      this.specialtyParam.specialtyOptions = data.specialtyOptions;
      if (
          data.specialtyList.length === 1 &&
          !data.specialtyList[0].specialtyName
      ) {
        this.collegeOrOptionsSpecialtyList = [];
      } else {
        this.collegeOrOptionsSpecialtyList = data.specialtyList || [];
      }
      this.editSpecialtyByOptionsDialogShow = true;
    },
    // 专业组模式编辑专业组
    editOptions(data) {
      this.specialtyOptionsParam.collegeName = data.collegeName;
      this.specialtyOptionsPlanList = data.optionsList || [];
      this.editCollegeSpecialtyOptionsDialogShow = true;
    },
    /**
     * 专业组 专业志愿弹框 添加专业点击
     */
    editSpecialtyByOptionsDialogAddClick() {
      this.selectedSpecialtyList = this.collegeOrOptionsSpecialtyList ? [...this.collegeOrOptionsSpecialtyList] : [];
      this.selectSpecialtyList();
      this.specialtyAddType = 2;
    },
    /**
     * 确认添加专业
     */
    confirmSelectSpecialty() {
      console.log(
          "specialtyAddType：" + this.specialtyAddType + "，volunteerMode：" + this.volunteerMode,
          "确定专业选择"
      );
      console.log([...this.selectedSpecialtyList].length, "确定已选专业数量");
      if (!this.selectedSpecialtyList || this.selectedSpecialtyList.length === 0) {
        this.$message({
          message: "请先选择专业",
          type: "warning",
        });
        return;
      }

      let selectedSpecialtyNameList = this.selectedSpecialtyList.map(specialty => {
        return specialty.collegeName + specialty.specialtyName;
      })

      if (this.specialtyAddType === 2) {
        if (this.volunteerMode === 1) {
          this.batchList.forEach((batch) => {
            if (batch.batch === this.currentBatchName) {
              batch.collegeList.forEach((college) => {
                if (college.collegeName === this.selectedSpecialtyList[0].collegeName) {
                  //匹配到对应院校
                  if (this.selectedSpecialtyList.length > 0 && !this.selectedSpecialtyList[0].specialtyName) {
                    //删除填充空专业
                    this.selectedSpecialtyList.splice(0, 1);
                  }
                  //院校原有专业，处理院校模式专业排序问题
                  if (college.specialtyList && college.specialtyList.length > 0 && !college.specialtyList[0].specialtyName) {
                    //删除填充空专业
                    college.specialtyList.splice(0, 1);
                  }

                  let collegeOriginalSpecialtyList = college.specialtyList ? [...college.specialtyList] : []
                  collegeOriginalSpecialtyList = collegeOriginalSpecialtyList.filter(specialty => {
                    return selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName);
                  })
                  collegeOriginalSpecialtyList.sort((a, b) => {
                    return a.psort - b.psort;
                  })
                  let collegeOriginalSpecialtySortMap = new Map();
                  collegeOriginalSpecialtyList.forEach((specialty, index) => {
                    specialty.psort = index + 1;
                    collegeOriginalSpecialtySortMap.set(specialty.collegeName + specialty.specialtyName, specialty.psort)
                  })

                  college.specialtyList = [...this.selectedSpecialtyList] || [];
                  college.specialtyList.forEach(specialty => {
                    specialty.scoreCollege = college.scoreYearThis;
                    //院校模式
                    specialty.sort = college.sort;
                    if (collegeOriginalSpecialtySortMap.has(specialty.collegeName + specialty.specialtyName)) {
                      //恢复原有专业顺序
                      specialty.psort = collegeOriginalSpecialtySortMap.get(specialty.collegeName + specialty.specialtyName)
                    } else {
                      //新专业 添加到末尾
                      specialty.psort = collegeOriginalSpecialtyList.length + 1
                      collegeOriginalSpecialtyList.push(specialty)
                    }
                  });
                  this.collegeOrOptionsSpecialtyList = [...college.specialtyList];
                }
              });

              this.currentBatch = {...batch};
              this.currentBatch.collegeList.sort((a, b) => {
                return a.sort - b.sort
              })
              this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
            }
          });
        } else if (this.volunteerMode === 2) {
          this.batchList.forEach((batch) => {
            if (batch.batch === this.currentBatchName) {
              //专业模式处理专业排序
              let originalSpecialtyList = []

              batch.collegeList.forEach(college => {
                if (college.specialtyList) {
                  if (college.specialtyList.length === 1 && !college.specialtyList[0].specialtyName) {
                    college.specialtyList = [];
                  }
                  originalSpecialtyList = [...originalSpecialtyList, ...college.specialtyList]
                }
              })
              console.log(originalSpecialtyList.length, "专业模式过滤前已选专业数量")
              let diffSpecialtyNameList = []

              this.originalCollegeOrOptionsSpecialtyList.forEach(specialty => {
                if (!selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName)) {
                  diffSpecialtyNameList.push(specialty.collegeName + specialty.specialtyName);
                }
              })
              console.log(diffSpecialtyNameList.toString(), "专业模式过滤专业")
              originalSpecialtyList = originalSpecialtyList.filter(specialty => {
                return !diffSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName)
              })

              console.log(originalSpecialtyList.length, "专业模式过滤后已选专业数量")
              let originalSpecialtyNameList = originalSpecialtyList.map(specialty => {
                return specialty.collegeName + specialty.specialtyName;
              })

              this.selectedSpecialtyList = this.selectedSpecialtyList.filter(specialty => {
                return !originalSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName)
              })

              originalSpecialtyList.sort((a, b) => {
                return a.psort - b.psort;
              })

              let originalSpecialtySortMap = new Map();
              originalSpecialtyList.forEach((specialty, index) => {
                specialty.psort = index + 1;
                originalSpecialtySortMap.set(specialty.collegeName + specialty.specialtyName, specialty.psort);
              })


              let allSpecialtyList = [...originalSpecialtyList, ...this.selectedSpecialtyList];
              console.log(allSpecialtyList.length, "专业模式专业总数")

              allSpecialtyList = allSpecialtyList.filter(specialty => {
                return specialty.specialtyName;
              })

              let collegeSpecialtyMap = new Map();

              allSpecialtyList.forEach(specialty => {
                let specialtyKey = specialty.collegeName + specialty.specialtyName;
                if (originalSpecialtySortMap.has(specialtyKey)) {
                  specialty.psort = originalSpecialtySortMap.get(specialtyKey)
                } else {
                  specialty.psort = originalSpecialtyList.length + 1;
                  originalSpecialtyList.push(specialty)
                }
                if (!collegeSpecialtyMap.has(specialty.collegeName)) {
                  collegeSpecialtyMap.set(specialty.collegeName, [])
                }
                collegeSpecialtyMap.get(specialty.collegeName).push(specialty)
              })


              batch.collegeList.forEach(college => {
                college.specialtyList = [];
                if (collegeSpecialtyMap.has(college.collegeName)) {
                  college.specialtyList = collegeSpecialtyMap.get(college.collegeName) || []
                }

                if (college.specialtyList.length === 0) {
                  let emptySpecialty = {
                    collegeCode: college.collegeCode,
                    collegeName: college.collegeName,
                    collegeProvince: college.collegeProvince,
                    collegeCity: college.collegeCity,
                    specialtyOptions: "",
                    admitBatch: college.admitBatch,
                    requiredType: college.requiredType,
                    specialtyUuid: college.collegeName,
                    sort: college.sort,
                    psort: originalSpecialtyList.length + 1,
                    requiredDiscipline: college.requiredDiscipline,
                    scoreYearThis2: college.scoreYearThis,
                    accumulateYearThis2: college.accumulateYearThis,
                    accumulateYearLast2: college.accumulateYearLast,
                    accumulateYearOther2: college.accumulateYearOther,
                    planYearLast2: college.planYearLast,
                    planYearThis2: college.planYearThis,
                    planDiff2: college.planDiff,
                    collegeCharacter: college.collegeCharacter,
                    collegeTag: college.collegeTag,
                    runType: college.runType,
                    tuitionFee: college.tuitionFee,
                    postgraduateAdmissionRate: college.postgraduateAdmissionRate,
                    masterSpecialtyNum: college.masterSpecialtyNum,
                    doctorSpecialtyNum: college.doctorSpecialtyNum,
                    softScienceRanking: college.softScienceRanking,
                    academicAssessment: college.academicAssessment,
                    masterSpecialty: college.masterSpecialty,
                    doctorSpecialty: college.doctorSpecialty,
                    isEmpty: 1,
                  }
                  college.specialtyList.push(emptySpecialty);
                  originalSpecialtyList.push(emptySpecialty)
                }
              })

              this.currentBatch = {...batch};
              this.currentBatch.collegeList.sort((a, b) => {
                return a.sort - b.sort
              })
              this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);

            }
          });
        } else {
          // 专业组顺向添加专业
          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              item.collegeList.forEach((college) => {
                if (college.collegeName === this.selectedSpecialtyList[0].collegeName) {
                  //查找到当前院校
                  college.optionsList.forEach((options) => {
                    if (options.collegeName === this.selectedSpecialtyList[0].collegeName &&
                        options.specialtyOptions === this.selectedSpecialtyList[0].specialtyOptions
                    ) {
                      //查找到当前专业组
                      if (this.selectedSpecialtyList.length > 0 && !this.selectedSpecialtyList[0].specialtyName) {
                        //删除填充空专业
                        this.selectedSpecialtyList.splice(0, 1);
                      }

                      if (!options.specialtyList) {
                        options.specialtyList = []
                      }
                      //专业组原有专业
                      let originalSpecialty = [...options.specialtyList] || [];

                      originalSpecialty = originalSpecialty.filter(item => {
                        return selectedSpecialtyNameList.includes(item.specialtyName);
                      })
                      originalSpecialty.sort((a, b) => {
                        return a.psort - b.psort;
                      })

                      let originalSpecialtyCount = originalSpecialty.length;
                      let originalSpecialtySortMap = new Map();
                      if (originalSpecialty.length > 0) {
                        originalSpecialty.forEach((specialty, index) => {
                          specialty.psort = index + 1;
                          originalSpecialtySortMap.set(specialty.specialtyName, specialty.psort);
                        })
                      }

                      options.specialtyList = [...this.selectedSpecialtyList] || [];
                      options.specialtyList.forEach(specialty => {
                        specialty.requiredType = options.requiredType;
                        specialty.requiredDiscipline = options.requiredDiscipline;
                        specialty.scoreCollege = options.scoreYearThis;
                        specialty.sort = options.sort;
                        if (originalSpecialtySortMap.get(specialty.specialtyName)) {
                          specialty.psort = originalSpecialtySortMap.get(specialty.specialtyName);
                        } else {
                          specialty.psort = originalSpecialtyCount + 1;
                          originalSpecialtyCount++;
                        }
                      });
                      this.collegeOrOptionsSpecialtyList = [...options.specialtyList];
                    }
                  });
                }
              });

              this.currentBatch = {...item};
              this.currentBatch.collegeList.sort((a, b) => {
                return a.sort - b.sort
              })
              this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
            }
          });
        }
      }
      if (this.specialtyAddType === 1) {
        // 直接添加专业
        if (this.volunteerMode !== 3) {
          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              if (this.volunteerMode === 2) {
                this.selectedSpecialtyList.forEach(specialty => {
                  specialty.scoreCollege = specialty.scoreYearThis2;
                });
              }

              //原有院校列表
              let originalCollegeNameList = [];
              if (item.collegeList && item.collegeList.length > 0) {
                item.collegeList.forEach((college) => {
                  originalCollegeNameList.push(college.collegeName);
                });
              } else {
                item.collegeList = [];
              }

              this.selectedSpecialtyList.forEach(specialty => {
                if (!originalCollegeNameList.includes(specialty.collegeName)) {
                  //填充院校
                  let fillCollege = {
                    admitBatch: specialty.admitBatch,
                    collegeCode: specialty.collegeCode,
                    collegeName: specialty.collegeName,
                    collegeProvince: specialty.collegeProvince,
                    collegeCity: specialty.collegeCity,
                    disciplineType: specialty.disciplineType,
                    planDiff: specialty.planDiff2,
                    accumulateYearLast: specialty.accumulateYearLast2,
                    accumulateYearOther: specialty.accumulateYearOther2,
                    accumulateYearThis: specialty.accumulateYearThis2,
                    scoreYearLast: specialty.scoreYearLast2,
                    scoreYearThis: specialty.scoreYearThis2,
                    scoreYearThis1: specialty.scoreYearThis,
                    scoreCollege: specialty.scoreYearThis2,
                    planYearLast: specialty.planYearLast2,
                    planYearThis: specialty.planYearThis2,
                    specialtyOptions: specialty.specialtyOptions,
                    specialtyNames: specialty.specialtyNames,
                    universityId: specialty.universityId,
                    year: specialty.year,
                    admissionYear: specialty.admissionYear,
                    province: specialty.province,
                    provinceId: specialty.provinceId,
                    specialtyUuid: specialty.collegeUuid,
                    collegeCharacter: specialty.collegeCharacter,
                    collegeTag: specialty.collegeTag,
                    runType: specialty.runType,
                    tuitionFee: specialty.tuitionFee,
                    postgraduateAdmissionRate: specialty.postgraduateAdmissionRate,
                    masterSpecialtyNum: specialty.masterSpecialtyNum,
                    doctorSpecialtyNum: specialty.doctorSpecialtyNum,
                    softScienceRanking: specialty.softScienceRanking,
                    academicAssessment: specialty.academicAssessment,
                    masterSpecialty: specialty.masterSpecialty,
                    doctorSpecialty: specialty.doctorSpecialty,
                    sort: originalCollegeNameList.length + 1 //排序添加到末尾
                  };
                  item.collegeList.push(fillCollege);
                  originalCollegeNameList.push(fillCollege.collegeName);
                }
              });

              if (this.volunteerMode === 1) {
                let specialtyCollegeMap = new Map();
                this.selectedSpecialtyList.forEach(specialty => {
                  if (specialty.specialtyName) {
                    let collegeNameKey = specialty.collegeName;
                    if (!specialtyCollegeMap.has(collegeNameKey)) {
                      specialtyCollegeMap.set(collegeNameKey, [])
                    }
                    specialtyCollegeMap.get(collegeNameKey).push(specialty)
                  }
                })

                item.collegeList.forEach((college) => {
                  //院校原有专业，处理院校模式专业排序问题
                  let collegeOriginalSpecialtyList = college.specialtyList ? [...college.specialtyList] : []
                  if (collegeOriginalSpecialtyList.length > 0 && !collegeOriginalSpecialtyList[0].specialtyName) {
                    //删除填充空专业
                    collegeOriginalSpecialtyList.splice(0, 1);
                  }

                  collegeOriginalSpecialtyList = collegeOriginalSpecialtyList.filter(specialty => {
                    return selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName);
                  })

                  collegeOriginalSpecialtyList.sort((a, b) => {
                    return a.psort - b.psort;
                  })

                  let collegeOriginalSpecialtySortMap = new Map();
                  collegeOriginalSpecialtyList.forEach((specialty, index) => {
                    specialty.psort = index + 1;
                    collegeOriginalSpecialtySortMap.set(specialty.collegeName + specialty.specialtyName, specialty.psort)
                  })

                  college.specialtyList = []

                  college.specialtyList = specialtyCollegeMap.get(college.collegeName) || [];
                  console.log(college.specialtyList.length, college.collegeName + "专业数量")
                  college.specialtyList.forEach(specialty => {
                    college.scoreYearThis = specialty.scoreYearThis2;
                    college.scoreCollege = specialty.scoreYearThis2;

                    specialty.scoreYearThis1 = specialty.scoreYearThis2;
                    specialty.planYearLast1 = specialty.planYearLast2;
                    specialty.planYearThis1 = specialty.planYearThis2;
                    specialty.planDiff1 = specialty.planYearThis1 - specialty.planYearLast1;

                    specialty.sort = college.sort;
                    if (collegeOriginalSpecialtySortMap.has(specialty.collegeName + specialty.specialtyName)) {
                      //恢复原有专业顺序
                      specialty.psort = collegeOriginalSpecialtySortMap.get(specialty.collegeName + specialty.specialtyName)
                    } else {
                      //新专业 添加到末尾
                      specialty.psort = collegeOriginalSpecialtyList.length + 1
                      collegeOriginalSpecialtyList.push(specialty)
                    }
                  });
                });
              }

              if (this.volunteerMode === 2) {
                //原有专业列表，专业模式处理专业排序
                let originalSpecialtyList = []

                item.collegeList.forEach(college => {
                  if (college.specialtyList) {
                    if (college.specialtyList.length === 1 && !college.specialtyList[0].specialtyName) {
                      college.specialtyList = []
                    }
                    originalSpecialtyList = [...originalSpecialtyList, ...college.specialtyList]
                  }
                })

                console.log(originalSpecialtyList.length, "专业模式添加专业时原专业数量")

                originalSpecialtyList = originalSpecialtyList.filter(specialty => {
                  return selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName)
                })

                originalSpecialtyList.sort((a, b) => {
                  return a.psort - b.psort;
                })

                let originalSpecialtySortMap = new Map();
                originalSpecialtyList.forEach(specialty => {
                  console.log(`${specialty.collegeName + specialty.specialtyName} 原序号：${specialty.psort}`)
                  // specialty.psort = index + 1;
                  originalSpecialtySortMap.set(specialty.collegeName + specialty.specialtyName, specialty.psort)
                })

                let specialtyCollegeMap = new Map();
                this.selectedSpecialtyList.forEach(specialty => {
                  let specialtyKey = specialty.collegeName + specialty.specialtyName;
                  if (specialty.specialtyName) {
                    let collegeNameKey = specialty.collegeName;
                    if (!specialtyCollegeMap.has(collegeNameKey)) {
                      specialtyCollegeMap.set(collegeNameKey, [])
                    }
                    if (originalSpecialtySortMap.has(specialtyKey)) {
                      specialty.psort = originalSpecialtySortMap.get(specialtyKey)
                    } else {
                      specialty.psort = originalSpecialtyList.length + 1;
                      originalSpecialtyList.push(specialty);
                    }
                    specialtyCollegeMap.get(collegeNameKey).push(specialty)
                  }
                })

                item.collegeList.forEach(college => {
                  college.specialtyList = specialtyCollegeMap.get(college.collegeName) || []

                  if (!college.specialtyList || college.specialtyList.length === 0) {
                    let emptySpecialty = {
                      collegeCode: college.collegeCode,
                      collegeName: college.collegeName,
                      collegeProvince: college.collegeProvince,
                      collegeCity: college.collegeCity,
                      specialtyOptions: "",
                      admitBatch: college.admitBatch,
                      requiredType: college.requiredType,
                      specialtyUuid: college.collegeName,
                      sort: college.sort,
                      psort: originalSpecialtyList.length + 1,
                      requiredDiscipline: college.requiredDiscipline,
                      scoreYearThis2: college.scoreYearThis,
                      accumulateYearThis2: college.accumulateYearThis,
                      accumulateYearLast2: college.accumulateYearLast,
                      accumulateYearOther2: college.accumulateYearOther,
                      planYearLast2: college.planYearLast,
                      planYearThis2: college.planYearThis,
                      planDiff2: college.planDiff,
                      collegeCharacter: college.collegeCharacter,
                      collegeTag: college.collegeTag,
                      runType: college.runType,
                      tuitionFee: college.tuitionFee,
                      postgraduateAdmissionRate: college.postgraduateAdmissionRate,
                      masterSpecialtyNum: college.masterSpecialtyNum,
                      doctorSpecialtyNum: college.doctorSpecialtyNum,
                      softScienceRanking: college.softScienceRanking,
                      academicAssessment: college.academicAssessment,
                      masterSpecialty: college.masterSpecialty,
                      doctorSpecialty: college.doctorSpecialty,
                      isEmpty: 1,
                    }
                    college.specialtyList = []
                    college.specialtyList.push(emptySpecialty);
                    originalSpecialtyList.push(emptySpecialty);
                  }
                })
              }


              this.currentBatch = {...item};
              // this.currentBatch.collegeList = [...collectCollegeList]
              this.currentBatch.collegeList.sort((a, b) => {
                return a.sort - b.sort
              })
              this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);

            }
          });
        } else {
          console.log("专业组模式直接添加专业");
          // 专业组模式直接添加专业
          this.batchList.forEach(batch => {
            if (batch.batch === this.currentBatchName) {
              //已经添加的院校列表 名称匹配
              let originalCollegeNameList = [];
              //汇总 院校列表
              let collectCollegeList = []

              //已经添加的专业组列表 名称匹配
              let originalSpecialtyOptionsNameList = [];
              //汇总 专业组列表
              let collectSpecialtyOptionsList = []
              //已有专业组的专业数量，专业排序用
              let originalOptionsSpecialtyCountMap = new Map();

              //已经添加的专业列表 名称匹配
              let originalSpecialtyNameList = [];
              //汇总 专业列表
              let collectSpecialtyList = []

              if (batch.collegeList && batch.collegeList.length > 0) {
                batch.collegeList.forEach(college => {
                  collectCollegeList.push(college);
                  originalCollegeNameList.push(college.collegeName);
                })
              } else {
                batch.collegeList = []
              }

              if (this.oldSelectSpecialtyOptionsList) {
                this.oldSelectSpecialtyOptionsList.forEach(options => {
                  console.log(options.specialtyOptions, "已经添加的专业组")
                  collectSpecialtyOptionsList.push(options);
                  originalSpecialtyOptionsNameList.push(options.collegeName + options.specialtyOptions)

                  if (options.specialtyList && options.specialtyList.length > 0) {
                    if (!options.specialtyList[0].specialtyName) {
                      //空专业
                      options.specialtyList.splice(0, 1);
                    }

                    options.specialtyList = options.specialtyList.filter(specialty => {
                      return selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName);
                    })
                    options.specialtyList.sort((a, b) => {
                      return a.psort - b.psort;
                    })
                    console.log(options.specialtyList.length, `${options.specialtyOptions} 专业组专业数量`)
                    options.specialtyList.forEach((specialty, index) => {
                      specialty.psort = index + 1;
                      collectSpecialtyList.push(specialty);
                      originalSpecialtyNameList.push(specialty.collegeName + specialty.specialtyName)
                    })

                    originalOptionsSpecialtyCountMap.set(options.collegeName + options.specialtyOptions, options.specialtyList.length)
                  } else {
                    originalOptionsSpecialtyCountMap.set(options.collegeName + options.specialtyOptions, 0)
                  }
                })
              }


              this.selectedSpecialtyList.forEach(selectedSpecialty => {
                console.log(selectedSpecialty, "选择的专业")
                //处理院校
                if (!originalCollegeNameList.includes(selectedSpecialty.collegeName)) {
                  //当前已经添加的院校志愿不包含该专业对应院校
                  //填充院校
                  let fillCollege = {
                    admitBatch: selectedSpecialty.admitBatch,
                    collegeCode: selectedSpecialty.collegeCode,
                    collegeName: selectedSpecialty.collegeName,
                    collegeProvince: selectedSpecialty.collegeProvince,
                    collegeCity: selectedSpecialty.collegeCity,
                    disciplineType: selectedSpecialty.disciplineType,
                    planDiff: selectedSpecialty.planDiff2,
                    accumulateYearLast: selectedSpecialty.accumulateYearLast2,
                    accumulateYearOther: selectedSpecialty.accumulateYearOther2,
                    accumulateYearThis: selectedSpecialty.accumulateYearThis2,
                    scoreYearLast: selectedSpecialty.scoreYearLast2,
                    scoreYearThis: selectedSpecialty.scoreYearThis2,
                    planYearLast: selectedSpecialty.planYearLast2,
                    planYearThis: selectedSpecialty.planYearThis2,
                    specialtyOptions: selectedSpecialty.specialtyOptions,
                    specialtyNames: selectedSpecialty.specialtyNames,
                    universityId: selectedSpecialty.universityId,
                    year: selectedSpecialty.year,
                    admissionYear: selectedSpecialty.admissionYear,
                    province: selectedSpecialty.province,
                    provinceId: selectedSpecialty.provinceId,
                    specialtyUuid: selectedSpecialty.collegeUuid,
                    optionsList: [],
                    collegeCharacter: selectedSpecialty.collegeCharacter,
                    collegeTag: selectedSpecialty.collegeTag,
                    runType: selectedSpecialty.runType,
                    tuitionFee: selectedSpecialty.tuitionFee,
                    postgraduateAdmissionRate: selectedSpecialty.postgraduateAdmissionRate,
                    masterSpecialtyNum: selectedSpecialty.masterSpecialtyNum,
                    doctorSpecialtyNum: selectedSpecialty.doctorSpecialtyNum,
                    softScienceRanking: selectedSpecialty.softScienceRanking,
                    academicAssessment: selectedSpecialty.academicAssessment,
                    masterSpecialty: selectedSpecialty.masterSpecialty,
                    doctorSpecialty: selectedSpecialty.doctorSpecialty,
                    sort: collectCollegeList.length + 1
                  }

                  collectCollegeList.push(fillCollege);
                  originalCollegeNameList.push(fillCollege.collegeName)
                }

                //处理专业组
                if (!originalSpecialtyOptionsNameList.includes(selectedSpecialty.collegeName + selectedSpecialty.specialtyOptions)) {
                  //当前已经添加的专业组志愿不包含该专业对应专业组
                  //填充专业组
                  let fillOptions = {
                    admitBatch: selectedSpecialty.admitBatch,
                    collegeCode: selectedSpecialty.collegeCode,
                    collegeName: selectedSpecialty.collegeName,
                    collegeProvince: selectedSpecialty.collegeProvince,
                    collegeCity: selectedSpecialty.collegeCity,
                    disciplineType: selectedSpecialty.disciplineType,
                    planDiff: selectedSpecialty.planDiff1,
                    accumulateYearLast: selectedSpecialty.accumulateYearLast1,
                    accumulateYearOther: selectedSpecialty.accumulateYearOther1,
                    accumulateYearThis: selectedSpecialty.accumulateYearThis1,
                    scoreYearLast: selectedSpecialty.scoreYearLast1,
                    scoreYearThis: selectedSpecialty.scoreYearThis1,
                    planYearLast: selectedSpecialty.planYearLast1,
                    planYearThis: selectedSpecialty.planYearThis1,
                    specialtyName: selectedSpecialty.specialtyName1,
                    specialtyOptions: selectedSpecialty.specialtyOptions,
                    specialtyNames: selectedSpecialty.specialtyNames,
                    requiredType: selectedSpecialty.requiredType,
                    requiredDiscipline: selectedSpecialty.requiredDiscipline,
                    universityId: selectedSpecialty.universityId,
                    year: selectedSpecialty.year,
                    sort: collectSpecialtyOptionsList.length + 1,
                    admissionYear: selectedSpecialty.admissionYear,
                    province: selectedSpecialty.province,
                    provinceId: selectedSpecialty.provinceId,
                    specialtyUuid: selectedSpecialty.collegeUuid,
                    specialtyList: [],
                    collegeCharacter: selectedSpecialty.collegeCharacter,
                    collegeTag: selectedSpecialty.collegeTag,
                    tuitionFee: selectedSpecialty.tuitionFee,
                    postgraduateAdmissionRate: selectedSpecialty.postgraduateAdmissionRate,
                    masterSpecialtyNum: selectedSpecialty.masterSpecialtyNum,
                    doctorSpecialtyNum: selectedSpecialty.doctorSpecialtyNum,
                    softScienceRanking: selectedSpecialty.softScienceRanking,
                    academicAssessment: selectedSpecialty.academicAssessment,
                    masterSpecialty: selectedSpecialty.masterSpecialty,
                    doctorSpecialty: selectedSpecialty.doctorSpecialty,
                    runType: selectedSpecialty.runType
                  }
                  console.log(collectSpecialtyOptionsList.length, "填充专业组前专业组数量")
                  console.log(fillOptions, "填充专业组")
                  collectSpecialtyOptionsList.push(fillOptions);
                  originalSpecialtyOptionsNameList.push(fillOptions.collegeName + fillOptions.specialtyOptions)
                }

                //处理专业
                if (!originalSpecialtyNameList.includes(selectedSpecialty.collegeName + selectedSpecialty.specialtyName)) {
                  collectSpecialtyOptionsList.forEach(options => {
                    if (selectedSpecialty.collegeName === options.collegeName &&
                        selectedSpecialty.specialtyOptions === options.specialtyOptions) {
                      if (!options.specialtyList) {
                        options.specialtyList = [];
                      }
                      let optionsKey = options.collegeName + options.specialtyOptions;
                      let optionsSpecialtyCount = 0;
                      if (originalOptionsSpecialtyCountMap.has(optionsKey)) {
                        optionsSpecialtyCount = originalOptionsSpecialtyCountMap.get(optionsKey);
                      }
                      if (selectedSpecialty.specialtyName) {
                        selectedSpecialty.aspirationName = selectedSpecialty.specialtyName1;
                        selectedSpecialty.sort = options.sort
                        selectedSpecialty.psort = optionsSpecialtyCount + 1;
                        originalOptionsSpecialtyCountMap.set(optionsKey, optionsSpecialtyCount + 1)

                        collectSpecialtyList.push(selectedSpecialty)
                        originalSpecialtyNameList.push(selectedSpecialty.collegeName + selectedSpecialty.specialtyName)
                      }
                    }
                  })
                }

              })

              console.log(collectCollegeList.length, "院校汇总数量")
              console.log(collectSpecialtyOptionsList.length, "专业组汇总数量")
              console.log(collectSpecialtyList.length, "专业汇总数量")

              let collectSpecialtyOptionsSortMap = new Map();
              collectSpecialtyOptionsList.forEach(options => {
                collectSpecialtyOptionsSortMap.set(options.collegeName + options.specialtyOptions, options.sort);
              })

              let collegeOptionsMap = new Map();
              collectSpecialtyOptionsList.forEach((options) => {
                options.sort = collectSpecialtyOptionsSortMap.get(options.collegeName + options.specialtyOptions)
                let collegeKey = options.collegeName;
                if (!collegeOptionsMap.has(collegeKey)) {
                  collegeOptionsMap.set(collegeKey, [])
                }
                collegeOptionsMap.get(collegeKey).push(options)
              })

              let optionsSpecialtyMap = new Map();
              collectSpecialtyList.forEach(specialty => {
                let specialtyKey = specialty.collegeName + specialty.specialtyOptions;
                if (!optionsSpecialtyMap.has(specialtyKey)) {
                  optionsSpecialtyMap.set(specialtyKey, [])
                }
                optionsSpecialtyMap.get(specialtyKey).push(specialty);
              })

              //对汇总的院校、专业组、专业进行重组
              collectCollegeList.forEach(college => {
                let collegeKey = college.collegeName;
                college.optionsList = collegeOptionsMap.get(collegeKey) || []

                college.optionsList.forEach(options => {
                  let specialtyKey = options.collegeName + options.specialtyOptions;
                  options.specialtyList = optionsSpecialtyMap.get(specialtyKey) || []
                  options.specialtyList.forEach(specialty => {
                    specialty.sort = options.sort;
                  })
                })
              })

              batch.collegeList = [...collectCollegeList];

              this.currentBatch = {...batch};
              this.currentBatch.collegeList.sort((a, b) => {
                return a.sort - b.sort
              })
              this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
            }
          })
        }
      }
      this.addSpecialtyDialogShow = false;
    },
    // 院校添加专业
    collegeAddSpecialty(data) {
      this.specialtyParam.collegeCode = data.collegeCode;
      this.specialtyParam.collegeName = data.collegeName;
      this.specialtyParam.specialtyOptions = data.specialtyOptions;
      this.selectedSpecialtyList = data.specialtyList ? [...data.specialtyList] : [];
      this.selectedSpecialtyList = this.selectedSpecialtyList.filter((item) => {
        return item.specialtyName;
      });
      this.originalCollegeOrOptionsSpecialtyList = [...this.selectedSpecialtyList]
      this.specialtyAddType = 2;
      this.selectSpecialtyList();
    },
    handleChangezy(page) {
      this.specialtyParam.current = page;
      this.selectSpecialtyList();
    },
    handleChangezyz(page) {
      this.specialtyOptionsParam.current = page;
      this.obtainSpecialtyOptionsList();
    },
    async selectSpecialtyList() {
      let res = {};
      let arr = [];
      if (this.specialtyParam.majorName1) {
        let specialtyArr = this.specialtyParam.majorName1.split(" ");
        if (specialtyArr) {
          specialtyArr.forEach(item => {
            if (item) {
              arr.push(item);
            }
          });
        }
      } else {
        arr = null;
      }
      this.specialtyParam.specialtys = arr;

      this.specialtyParam.isMinority = this.studentInfo.isMinority;
      this.specialtyParam.isNationalSpecial = this.studentInfo.isNationalSpecial;
      this.specialtyParam.isLocalSpecial = this.studentInfo.isLocalSpecial;
      this.specialtyParam.isUniversitySpecial = this.studentInfo.isUniversitySpecial;
      this.specialtyParam.colorWeakness = this.studentInfo.colorWeakness;

      if (this.volunteerMode !== 3) {
        res = await selectCollegeSpecialtyList(this.specialtyParam);
      } else {
        // 专业组
        res = await selectSpecialtyOptionsList(this.specialtyParam);
      }
      let data = res.data || {};
      this.addSpecialtyTotal = data.total || 0;
      this.addSpecialtyDialogDataList = data.records || [];
      if (this.addSpecialtyDialogDataList && this.addSpecialtyDialogDataList.length > 0) {
        this.planYear = this.addSpecialtyDialogDataList[0].year;
        this.admissionYear = this.addSpecialtyDialogDataList[0].admissionYear;
      }
      let selectionList = [];
      if (this.selectedSpecialtyList && this.selectedSpecialtyList.length > 0) {
        let selectedSpecialtyNameList = this.selectedSpecialtyList.map(
            (specialty) => {
              return specialty.collegeName + specialty.specialtyName;
            }
        );
        selectionList = this.addSpecialtyDialogDataList.filter((specialty) => {
          return selectedSpecialtyNameList.includes(specialty.collegeName + specialty.specialtyName);
        })
      }
      this.toggleSelection(selectionList, "addSpecialtyTable");
      this.addSpecialtyDialogShow = true;
    },
    //选择专业
    handleSpecialtySelectionChanged(arr, row) {
      console.log(row, "row");
      let isHaveItem = this.selectedSpecialtyList.find(
          (item) =>
              item.collegeName === row.collegeName &&
              item.specialtyName === row.specialtyName
      );
      console.log(isHaveItem, "isHaveItem");
      if (isHaveItem) {
        this.selectedSpecialtyList = this.selectedSpecialtyList.filter(
            (item) =>
                item.collegeName !== isHaveItem.collegeName ||
                item.specialtyName !== isHaveItem.specialtyName
        );
      } else {
        row.psort = null;
        this.selectedSpecialtyList.push(row);
      }
    },
    handleSpecialtyRowSelectionChanged(row, col, event) {
      row.flag = !row.flag;
      let isflag = null;
      let isHaveItem = this.selectedSpecialtyList.find(
          (item) =>
              row.collegeName === item.collegeName &&
              row.specialtyName === item.specialtyName
      );
      if (isHaveItem) {
        isflag = false;
        this.selectedSpecialtyList = this.selectedSpecialtyList.filter(
            (item) =>
                isHaveItem.collegeName !== item.collegeName ||
                isHaveItem.specialtyName !== item.specialtyName
        );
      } else {
        isflag = true;
        row.psort = null;
        this.selectedSpecialtyList.push(row);
      }
      // this.selectedSpecialtyList = this.selectedSpecialtyList.filter(item => {
      //   return row.collegeName === item.collegeName && (!item.isEmpty || item.isEmpty !== 1)
      // })
      this.$refs.addSpecialtyTable.toggleRowSelection(row, isflag);
    },
    /**
     * 合并去重
     * @param arr1
     * @param arr2
     * @returns {any[]}
     * @constructor
     */
    MergeArray(arr1, arr2) {
      let map = new Map();
      let list = [...arr1, ...arr2];
      list.forEach(item => {
        if (!map.has(item.specialtyUuid)) {
          map.set(item.specialtyUuid, item);
        }
      })
      return [...map.values()];
    },

    //全选院校
    selectAllCollege(select) {
      if (select.length > 0) {
        this.selectedCollegeList = this.MergeArray(this.selectedCollegeList, select);
      } else {
        let collegePlanNameList = this.collegePlanList.map(college => {
          return college.collegeName;
        })
        this.selectedCollegeList = this.selectedCollegeList.filter(college => {
          return !collegePlanNameList.includes(college.collegeName)
        });
      }
    },

    // 全选专业
    selectAllSpecialty(select) {
      if (select.length > 0) {
        this.selectedSpecialtyList = this.MergeArray(this.selectedSpecialtyList, select);
      } else {
        let addSpecialtyDialogDataNameList = this.addSpecialtyDialogDataList.map(specialty => {
          return specialty.collegeName + specialty.specialtyName;
        })
        this.selectedSpecialtyList = this.selectedSpecialtyList.filter(specialty => {
          return !addSpecialtyDialogDataNameList.includes(specialty.collegeName + specialty.specialtyName)
        });
      }


    },
    // 全选专业组
    selectAllSpecialtyOptions(select) {
      if (select.length > 0) {
        this.selectedSpecialtyOptionsList = this.MergeArray(this.selectedSpecialtyOptionsList, select);
      } else {
        let addSpecialtyOptionsDialogDataNameList = this.addSpecialtyOptionsDialogDataList.map(options => {
          return options.collegeName + options.specialtyOptions;
        })
        this.selectedSpecialtyOptionsList = this.selectedSpecialtyOptionsList.filter(options => {
          return !addSpecialtyOptionsDialogDataNameList.includes(options.collegeName + options.specialtyOptions)
        });
      }
    },
    // 选择专业组
    handleSelectionChangeOptions(arr, row) {
      let isHaveItem = this.selectedSpecialtyOptionsList.find(
          (item) =>
              item.collegeName === row.collegeName &&
              item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        this.selectedSpecialtyOptionsList = this.selectedSpecialtyOptionsList.filter(
            (item) =>
                item.collegeName !== isHaveItem.collegeName &&
                item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        this.selectedSpecialtyOptionsList.push(row);
      }

      let selectedSpecialtyOptionsNameList = this.selectedSpecialtyOptionsList.map(options => {
        return options.specialtyOptions;
      })
      console.log(selectedSpecialtyOptionsNameList.toString(), "选择的专业组")
    },
    handleRowSelectionChangeOptions(row, col, event) {
      row.flag = !row.flag;
      let flag = null;
      let isHaveItem = this.selectedSpecialtyOptionsList.find(
          (item) =>
              item.collegeName === row.collegeName &&
              item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        flag = false;
        this.selectedSpecialtyOptionsList = this.selectedSpecialtyOptionsList.filter(
            (item) =>
                item.collegeName !== isHaveItem.collegeName ||
                item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        flag = true;
        this.selectedSpecialtyOptionsList.push(row);
      }
      let selectedSpecialtyOptionsNameList = this.selectedSpecialtyOptionsList.map(options => {
        return options.specialtyOptions;
      })
      console.log(selectedSpecialtyOptionsNameList.toString(), "选择的专业组")

      this.$refs.addOptionsTable.toggleRowSelection(row, flag);
    },
    //选择学校
    handleCollegeSelectionChanged(arr, row) {
      let isHaveItem = this.selectedCollegeList.find(
          (item) =>
              item.collegeName === row.collegeName &&
              item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        this.selectedCollegeList = this.selectedCollegeList.filter(
            (item) =>
                item.collegeName !== isHaveItem.collegeName ||
                item.specialtyOptions !== isHaveItem.specialtyOptions
        );
      } else {
        this.selectedCollegeList.push(row);
      }
    },
    handleCollegeRowSelectionChanged(row, col, event) {
      row.flag = !row.flag;
      let flag = null;
      let school = [...this.selectedCollegeList];
      console.log(school, "选择学校");
      let isHaveItem = this.selectedCollegeList.find(
          (item) =>
              item.collegeName === row.collegeName &&
              item.specialtyOptions === row.specialtyOptions
      );
      if (isHaveItem) {
        flag = false;
        this.selectedCollegeList = this.selectedCollegeList.filter(
            (item) =>
                item.collegeName !== isHaveItem.collegeName ||
                item.specialtyOptions !== row.specialtyOptions
        );
      } else {
        flag = true;
        this.selectedCollegeList.push(row);
      }
      this.$refs.addCollegeTable.toggleRowSelection(row, flag);
    },
    // 确认专业组
    confirmSelectOptions() {
      console.log(this.addSpecialtyOptionsType, "添加专业组确认");
      console.log(this.selectedSpecialtyOptionsList.length, "添加专业组确认数量");
      let selectedSpecialtyOptionsNameList = this.selectedSpecialtyOptionsList.map(options => {
        return options.collegeName + options.specialtyOptions;
      })
      console.log(selectedSpecialtyOptionsNameList.toString(), "添加专业组确认的专业组");

      if (this.addSpecialtyOptionsType === 1) {
        //筛选出新选择的和原有的区别
        let diffOptionsNameList = []
        this.originalCollegeSpecialOptionsList.forEach(options => {
          if (!selectedSpecialtyOptionsNameList.includes(options.collegeName + options.specialtyOptions)) {
            diffOptionsNameList.push(options.collegeName + options.specialtyOptions);
          }
        })

        this.oldSelectSpecialtyOptionsList = this.oldSelectSpecialtyOptionsList.filter(options => {
          return !diffOptionsNameList.includes(options.collegeName + options.specialtyOptions)
        })
      }
      //广西专业组模式非专科批自动添加专业 25.06.29更改为 专科批也需要自动添加
      if (this.studentInfo.province === "450000" && this.volunteerMode === 3) {
        this.autoSelectSpecialtyIndex = 0;

        let oldSelectSpecialtyOptionsNameList = this.oldSelectSpecialtyOptionsList.map(options => {
          return options.collegeName + options.specialtyOptions;
        })
        // console.log(oldSelectSpecialtyOptionsNameList.toString(), "添加专业组确认时原有专业组");

        this.newSelectSpecialtyOptionsList = this.selectedSpecialtyOptionsList.filter((item) => {
          return !oldSelectSpecialtyOptionsNameList.includes(item.collegeName + item.specialtyOptions);
        });

        let newSelectSpecialtyOptionsNameList = this.newSelectSpecialtyOptionsList.map(options => {
          return options.specialtyOptions;
        })

        console.log(newSelectSpecialtyOptionsNameList.toString(), "添加专业组确认新选择的专业组");

        if (this.newSelectSpecialtyOptionsList && this.newSelectSpecialtyOptionsList.length > 0) {
          this.selectedSpecialtyList = [];
          this.autoSelectSpecialtyIndex = 0;
          this.autoSelectSpecialty();
        } else {
          this.addSpecialtyOptionsDialogShow = false;
        }
      } else {
        this.addSpecialtyOptions();
      }
    },

    autoSelectSpecialty() {
      selectSpecialtyOptionsListV2({
        collegeName:
        this.newSelectSpecialtyOptionsList[this.autoSelectSpecialtyIndex].collegeName,
        specialtyOptions:
        this.newSelectSpecialtyOptionsList[this.autoSelectSpecialtyIndex].specialtyOptions,
        provinceId: this.studentInfo.province,
        admitBatch: this.currentBatchName,
        accumulate: this.specialtyParam.accumulate,
        disciplines: this.specialtyParam.disciplines,
        disciplineType: this.studentInfo.disciplineType,
        isMinority: this.studentInfo.isMinority,
        isNationalSpecial: this.studentInfo.isNationalSpecial,
        isLocalSpecial: this.studentInfo.isLocalSpecial,
        isUniversitySpecial: this.studentInfo.isUniversitySpecial,
        colorWeakness: this.studentInfo.colorWeakness,
        year: this.studentInfo.graduateYear,
      }).then((res) => {
        if (res.code === 1) {
          let data = res.data || {};
          let records = [...data.records] || [];
          this.selectedSpecialtyList = [...this.selectedSpecialtyList, ...records];
        }

        this.autoSelectSpecialtyIndex++;
        if (this.autoSelectSpecialtyIndex < this.newSelectSpecialtyOptionsList.length) {
          this.autoSelectSpecialty();
        } else {
          if (this.selectedSpecialtyList.length > 0) {
            //将原有专业添加

            let originalSpecialtyOptionsNameList = []
            if (this.oldSelectSpecialtyOptionsList) {
              this.oldSelectSpecialtyOptionsList.forEach(options => {
                originalSpecialtyOptionsNameList.push(options.specialtyOptions)
                if (options.specialtyList) {
                  this.selectedSpecialtyList = [...this.selectedSpecialtyList, ...options.specialtyList];
                }
              })
            }

            console.log(originalSpecialtyOptionsNameList.toString(), "自动添加专业组专业完毕原有专业组")
            this.specialtyAddType = 1;
            this.confirmSelectSpecialty();
          } else {
            this.addSpecialtyOptions();
          }
          this.addSpecialtyOptionsDialogShow = false;
        }
      });
    },

    /**
     * 添加专业组
     */
    addSpecialtyOptions() {
      if (this.selectedSpecialtyOptionsList && this.selectedSpecialtyOptionsList.length > 0) {
        let selectedSpecialtyOptionsNameList = this.selectedSpecialtyOptionsList.map(options => {
          return options.collegeName + options.specialtyOptions;
        })
        console.log(selectedSpecialtyOptionsNameList.toString(), "添加的专业组列表")

        if (this.addSpecialtyOptionsType === 0) {
          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              //已经选择院校列表
              let originalCollegeList = [];
              let originalCollegeNameList = [];
              //已经选择的专业组列表
              let originalSpecialtyOptionsList = [];
              if (item.collegeList && item.collegeList.length > 0) {
                originalCollegeList = [...item.collegeList];
                item.collegeList.forEach((college) => {
                  originalCollegeNameList.push(college.collegeName);
                  if (college.optionsList && college.optionsList.length > 0) {
                    originalSpecialtyOptionsList = [...originalSpecialtyOptionsList, ...college.optionsList];
                  }
                });
              } else {
                item.collegeList = [];
              }
              originalSpecialtyOptionsList = originalSpecialtyOptionsList.filter(options => {
                return selectedSpecialtyOptionsNameList.includes(options.collegeName + options.specialtyOptions);
              })

              originalSpecialtyOptionsList.sort((a, b) => {
                return a.sort - b.sort;
              })

              let originalSpecialtyOptionsSortMap = new Map();
              originalSpecialtyOptionsList.forEach((options, index) => {
                options.sort = index + 1;
                originalSpecialtyOptionsSortMap.set(options.collegeName + options.specialtyOptions, options.sort);
              })

              //从专业组中添加院校
              this.selectedSpecialtyOptionsList.forEach((options) => {
                let optionsKey = options.collegeName + options.specialtyOptions;
                if (originalSpecialtyOptionsSortMap.has(optionsKey)) {
                  options.sort = originalSpecialtyOptionsSortMap.get(optionsKey);
                } else {
                  options.sort = originalSpecialtyOptionsList.length + 1;
                  originalSpecialtyOptionsList.push(options);
                }

                if (!originalCollegeNameList.includes(options.collegeName)) {
                  originalCollegeNameList.push(options.collegeName);
                  let fillCollege = {
                    admitBatch: options.admitBatch,
                    collegeCode: options.collegeCode,
                    collegeName: options.collegeName,
                    collegeProvince: options.collegeProvince,
                    disciplineType: options.disciplineType,
                    accumulateYearLast: options.accumulateYearLast2,
                    accumulateYearOther: options.accumulateYearOther2,
                    accumulateYearThis: options.accumulateYearThis2,
                    scoreYearLast: options.scoreYearLast2,
                    scoreYearThis: options.scoreYearThis2,
                    planYearLast: options.planYearLast2,
                    planYearThis: options.planYearThis2,
                    planDiff: options.planYearThis2 - options.planYearLast2,
                    specialtyOptions: options.specialtyOptions,
                    specialtyNames: options.specialtyNames,
                    universityId: options.universityId,
                    year: options.year,
                    admissionYear: options.admissionYear,
                    province: options.province,
                    provinceId: options.provinceId,
                    specialtyUuid: options.collegeUuid,
                    collegeCharacter: options.collegeCharacter,
                    collegeTag: options.collegeTag,
                    runType: options.runType,
                    postgraduateAdmissionRate: options.postgraduateAdmissionRate,
                    masterSpecialtyNum: options.masterSpecialtyNum,
                    doctorSpecialtyNum: options.doctorSpecialtyNum
                  };
                  item.collegeList.push(fillCollege);
                }
              });

              let originalCollegeSortMap = new Map();
              originalCollegeList.forEach(college => {
                let collegeKey = college.collegeName;
                if (college.sort) {
                  originalCollegeSortMap.set(collegeKey, college.sort);
                }
              })

              item.collegeList.forEach(college => {
                let collegeKey = college.collegeName;
                if (originalCollegeSortMap.has(collegeKey)) {
                  college.sort = originalCollegeSortMap.get(collegeKey);
                } else {
                  college.sort = originalCollegeList.length + 1;
                  originalCollegeList.push(college);
                }
              });

              //将选择的专业组根据院校名称用map分组
              let map = new Map();
              this.selectedSpecialtyOptionsList.forEach((item) => {
                if (!map.has(item.collegeName)) {
                  map.set(item.collegeName, []);
                }
                map.get(item.collegeName).push(item);
              });
              console.log(map, "院校专业组");

              item.collegeList.forEach((college) => {
                college.optionsList = map.get(college.collegeName);
                this.selectedSpecialtyOptionsList.forEach((options) => {
                  if (
                      !options.specialtyList ||
                      options.specialtyList.length < 1
                  ) {
                    options.specialtyList = [
                      {
                        collegeCode: options.collegeCode,
                        collegeName: options.collegeName,
                        specialtyNames: options.specialtyNames,
                        specialtyOptions: options.specialtyOptions,
                        specialtyName1: options.specialtyName,
                        admitBatch: options.admitBatch,
                        requiredType: options.requiredType,
                        specialtyUuid: options.specialtyOptions,
                        sort: options.sort,
                        requiredDiscipline: options.requiredDiscipline,
                        scoreYearThis1: options.scoreYearThis,
                        accumulateYearThis2: options.accumulateYearThis,
                        accumulateYearLast2: options.accumulateYearLast,
                        accumulateYearOther2: options.accumulateYearOther,
                        planYearLast2: options.planYearLast,
                        planYearThis2: options.planYearThis,
                        planDiff2: options.planDiff,
                        collegeCharacter: options.collegeCharacter,
                        collegeTag: options.collegeTag,
                        tuitionFee: options.tuitionFee,
                        postgraduateAdmissionRate: options.postgraduateAdmissionRate,
                        masterSpecialtyNum: options.masterSpecialtyNum,
                        doctorSpecialtyNum: options.doctorSpecialtyNum,
                        softScienceRanking: options.softScienceRanking,
                        academicAssessment: options.academicAssessment,
                        masterSpecialty: options.masterSpecialty,
                        doctorSpecialty: options.doctorSpecialty,
                        runType: options.runType
                      },
                    ];
                  }
                });
              });
            }
          });
        } else {

          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              let originalSpecialtyOptionsList = [];
              if (this.addSpecialtyOptionsType === 1) {
                //筛选出新选择的和原有的区别
                let diffOptionsNameList = []
                this.originalCollegeSpecialOptionsList.forEach(options => {
                  if (!selectedSpecialtyOptionsNameList.includes(options.collegeName + options.specialtyOptions)) {
                    diffOptionsNameList.push(options.collegeName + options.specialtyOptions);
                  }
                })

                console.log(diffOptionsNameList.toString(), "添加专业组变换的专业组")

                this.oldSelectSpecialtyOptionsList = this.oldSelectSpecialtyOptionsList.filter(options => {
                  return !diffOptionsNameList.includes(options.collegeName + options.specialtyOptions)
                })
              }

              if (this.oldSelectSpecialtyOptionsList) {
                originalSpecialtyOptionsList = [...this.oldSelectSpecialtyOptionsList] || []
              }

              originalSpecialtyOptionsList.sort((a, b) => {
                return a.sort - b.sort;
              })
              let originalSpecialtyOptionsSortMap = new Map();

              originalSpecialtyOptionsList.forEach((options, index) => {
                options.sort = index + 1;
                console.log(`原专业组${options.specialtyOptions} 原序号：${options.sort}`)
                originalSpecialtyOptionsSortMap.set(options.collegeName + options.specialtyOptions, options.sort);
              })

              let originalSpecialtyOptionsNameList = originalSpecialtyOptionsList.map(options => {
                return options.collegeName + options.specialtyOptions;
              })
              console.log(originalSpecialtyOptionsNameList.toString(), "添加专业组时已经添加的专业组")

              this.selectedSpecialtyOptionsList.forEach(options => {
                let optionsKey = options.collegeName + options.specialtyOptions;
                if (originalSpecialtyOptionsSortMap.has(optionsKey)) {
                  options.sort = originalSpecialtyOptionsSortMap.get(optionsKey);
                } else {
                  options.sort = originalSpecialtyOptionsList.length + 1;
                  originalSpecialtyOptionsList.push(options);
                }
              })

              item.collegeList.forEach((college) => {
                if (college.collegeName === this.selectedSpecialtyOptionsList[0].collegeName) {
                  college.optionsList = this.selectedSpecialtyOptionsList;
                }
                if (college.optionsList) {
                  college.optionsList.forEach((options) => {
                    if (!options.specialtyList || options.specialtyList.length < 1) {
                      options.specialtyList = [
                        {
                          collegeCode: options.collegeCode,
                          collegeName: options.collegeName,
                          specialtyNames: options.specialtyNames,
                          specialtyOptions: options.specialtyOptions,
                          specialtyName1: options.specialtyName,
                          admitBatch: options.admitBatch,
                          requiredType: options.requiredType,
                          specialtyUuid: options.specialtyOptions,
                          sort: options.sort,
                          requiredDiscipline: options.requiredDiscipline,
                          scoreYearThis1: options.scoreYearThis,
                          accumulateYearThis2: options.accumulateYearThis,
                          accumulateYearLast2: options.accumulateYearLast,
                          accumulateYearOther2: options.accumulateYearOther,
                          planYearLast2: options.planYearLast,
                          planYearThis2: options.planYearThis,
                          planDiff2: options.planDiff,
                          collegeCharacter: options.collegeCharacter,
                          collegeTag: options.collegeTag, collegeTag: options.collegeTag,
                          tuitionFee: options.tuitionFee,
                          postgraduateAdmissionRate: options.postgraduateAdmissionRate,
                          masterSpecialtyNum: options.masterSpecialtyNum,
                          doctorSpecialtyNum: options.doctorSpecialtyNum,
                          softScienceRanking: options.softScienceRanking,
                          academicAssessment: options.academicAssessment,
                          masterSpecialty: options.masterSpecialty,
                          doctorSpecialty: options.doctorSpecialty,
                          runType: options.runType
                        },
                      ];
                    }
                  });
                }
              });
            }
          });
        }

        this.batchList.forEach((item) => {
          if (item.batch === this.currentBatchName) {
            this.currentBatch = {...item};
            this.currentBatch.collegeList.sort((a, b) => {
              return a.sort - b.sort
            })
            this.$refs.volunteerTable.refreshData(
                this.currentBatch.collegeList
            );
          }
        });
        this.addSpecialtyOptionsDialogShow = false;
      } else {
        this.$message({
          message: "请先选择专业组",
          type: "warning",
        });
      }
    },
    /**
     * 院校添加确认
     */
    confirmSelectCollege() {
      if (this.selectedCollegeList.length === 0) {
        this.$message({
          message: "请先选择院校",
          type: "warning",
        });
        return;
      }

      //原有院校
      let originalCollegeList = []
      let originalSpecialtyList = []

      this.batchList.forEach(batch => {
        if (batch.batch === this.currentBatchName) {
          if (batch.collegeList && batch.collegeList.length > 0) {
            originalCollegeList = [...batch.collegeList];
            batch.collegeList.forEach(college => {
              if (college.specialtyList && college.specialtyList.length > 0) {
                originalSpecialtyList = [...originalSpecialtyList, ...college.specialtyList];
              }
            })
          }
        }
      })

      //选择的院校名称列表
      let selectedCollegeNameList = this.selectedCollegeList.map(college => {
        return college.collegeName;
      })

      originalCollegeList = originalCollegeList.filter(college => {
        return selectedCollegeNameList.includes(college.collegeName)
      })
      originalCollegeList.sort((a, b) => {
        return a.sort - b.sort;
      })

      let originalCollegeSortMap = new Map();

      originalCollegeList.forEach((college, index) => {
        college.sort = index + 1;
        originalCollegeSortMap.set(college.collegeName, college.sort);
      })


      this.selectedCollegeList.forEach(college => {
        if (originalCollegeSortMap.has(college.collegeName)) {
          college.sort = originalCollegeSortMap.get(college.collegeName);
        } else {
          college.sort = originalCollegeList.length + 1;
          originalCollegeList.push(college);
        }

        if (this.volunteerMode !== 3) {
          if (!college.specialtyList || college.specialtyList.length === 0) {
            let emptySpecialty = {
              collegeCode: college.collegeCode,
              collegeName: college.collegeName,
              collegeProvince: college.collegeProvince,
              collegeCity: college.collegeCity,
              specialtyOptions: "",
              admitBatch: college.admitBatch,
              requiredType: college.requiredType,
              specialtyUuid: college.collegeName,
              sort: college.sort,
              psort: originalSpecialtyList.length + 1,
              requiredDiscipline: college.requiredDiscipline,
              scoreYearThis2: college.scoreYearThis,
              accumulateYearThis2: college.accumulateYearThis,
              accumulateYearLast2: college.accumulateYearLast,
              accumulateYearOther2: college.accumulateYearOther,
              planYearLast2: college.planYearLast,
              planYearThis2: college.planYearThis,
              planDiff2: college.planDiff,
              collegeCharacter: college.collegeCharacter,
              collegeTag: college.collegeTag,
              runType: college.runType,
              tuitionFee: college.tuitionFee,
              postgraduateAdmissionRate: college.postgraduateAdmissionRate,
              masterSpecialtyNum: college.masterSpecialtyNum,
              doctorSpecialtyNum: college.doctorSpecialtyNum,
              softScienceRanking: college.softScienceRanking,
              academicAssessment: college.academicAssessment,
              masterSpecialty: college.masterSpecialty,
              doctorSpecialty: college.doctorSpecialty,
              isEmpty: 1,
            }
            college.specialtyList = [];
            college.specialtyList.push(emptySpecialty);
            originalSpecialtyList.push(emptySpecialty);
          } else {
            college.scoreYearThis2 = college.specialtyList[0].scoreYearThis2;
          }
        }
      });

      this.selectedCollegeList.sort((a, b) => {
        return a.sort - b.sort;
      })

      this.batchList.forEach((batch) => {
        if (batch.batch === this.currentBatchName) {
          batch.collegeList = [...this.selectedCollegeList] || [];
          this.currentBatch = {...batch};
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      this.addCollegeDialogShow = false;
    },
    // 获取高考等位分
    selectEqualScore() {
      selectEqualScore(this.collegeParam).then((res) => {
        if (res.code === 1) {
          this.equalScore = res.data || 0;
        }
      });
    },
    collegeChanged(data) {
      this.batchList.forEach((item) => {
        if (item.batch === this.currentBatchName) {
          item.collegeList = [...data] || [];
          this.currentBatch = {...item};
          this.$refs.volunteerTable.refreshData(this.currentBatch.collegeList);
        }
      });
      // this.automaticallySaved();
    },
    // 添加院校志愿
    addCollegeClick() {
      this.selectedCollegeList = [];
      this.batchList.forEach((item) => {
        if (item.batch === this.currentBatchName) {
          if (item.collegeList) {
            this.selectedCollegeList = [...item.collegeList] || [];
          } else {
            this.selectedCollegeList = [];
          }
        }
      });
      this.addCollegeDialogShow = true;
      this.collegeParam.isOptions = 0;
      this.collegeParam.isMinority = this.studentInfo.isMinority;
      this.collegeParam.isNationalSpecial = this.studentInfo.isNationalSpecial;
      this.collegeParam.isLocalSpecial = this.studentInfo.isLocalSpecial;
      this.collegeParam.isUniversitySpecial = this.studentInfo.isUniversitySpecial;
      this.collegeParam.colorWeakness = this.studentInfo.colorWeakness;
      this.selectEqualScore();
    },
    // 院校回显
    // 在获取tableData数据的接口中调用
    toggleSelection(rows, refname) {
      this.$nextTick(() => {
        this.$refs[refname].clearSelection();
        if (rows && rows.length > 0) {
          rows.forEach((row) => {
            this.$refs[refname].toggleRowSelection(row, true);
          });
        }
      });
    },
    handleChange(page) {
      this.collegeParam.current = page;
      this.obtainCollegeList();
    },
    //获取高校
    obtainCollegeList() {
      selectCollegeList(this.collegeParam).then((res) => {
        let data = res.data || {};
        this.addCollegeTotal = data.total || 0;
        this.collegePlanList = data.records || [];
        if (this.collegePlanList && this.collegePlanList.length > 0) {
          this.planYear = this.collegePlanList[0].year;
          this.admissionYear = this.collegePlanList[0].admissionYear;
        }
        let selectionList = [];
        if (this.selectedCollegeList && this.selectedCollegeList.length >= 0) {
          let selectedCollegeNameList = this.selectedCollegeList.map(
              (college) => {
                return college.collegeName;
              }
          );
          selectionList = this.collegePlanList.filter((college) => {
            return selectedCollegeNameList.includes(college.collegeName);
          })
        }
        this.toggleSelection(selectionList, "addCollegeTable");
        this.addCollegeDialogShow = true;
      });
    },
    //获取专业组
    async obtainSpecialtyOptionsList() {
      let res = {};
      if (this.addSpecialtyOptionsType === 1) {
        res = await selectCollegeList(this.specialtyOptionsParam);
      }
      if (this.addSpecialtyOptionsType === 0) {
        res = await selectCollegeOptionsList(this.specialtyOptionsParam);
      }
      let data = res.data || {};
      this.addOptionsTotal = data.total || 0;
      this.addSpecialtyOptionsDialogDataList = data.records || [];
      if (this.addSpecialtyOptionsDialogDataList && this.addSpecialtyOptionsDialogDataList.length > 0) {
        this.planYear = this.addSpecialtyOptionsDialogDataList[0].year;
        this.admissionYear = this.addSpecialtyOptionsDialogDataList[0].admissionYear;
      }
      let selectionList = [];
      if (this.selectedSpecialtyOptionsList && this.selectedSpecialtyOptionsList.length >= 0) {
        let selectedSpecialtyOptionsNameList = this.selectedSpecialtyOptionsList.map(
            (options) => {
              return options.collegeName + options.specialtyOptions;
            }
        );
        selectionList = this.addSpecialtyOptionsDialogDataList.filter((options) => {
          return selectedSpecialtyOptionsNameList.includes(options.collegeName + options.specialtyOptions);
        })
      }
      this.toggleSelection(selectionList, "addOptionsTable");
    },
    // 获取省份
    getProvinceList() {
      getProvinceList({}).then((res) => {
        if (res.code === 1) {
          this.options1 = res.data || [];
        }
      });
    },
    //获取学生详情
    getStudentDetail(id) {
      getStudentDetail({studentId: id}).then((res) => {
        this.studentInfo = res.data || {};
        this.collegeParam.disciplineType = this.studentInfo.disciplineType;
        this.specialtyParam.disciplineType = this.studentInfo.disciplineType;
        this.specialtyOptionsParam.disciplineType = this.studentInfo.disciplineType;
        if (this.studentInfo.disciplineType === 1) {
          this.collegeParam.disciplines = ["物理", "化学", "生物"];
          this.specialtyParam.disciplines = ["物理", "化学", "生物"];
          this.specialtyOptionsParam.disciplines = ["物理", "化学", "生物"];
        }
        if (this.studentInfo.disciplineType === 2) {
          this.collegeParam.disciplines = ["历史", "地理", "政治"];
          this.specialtyParam.disciplines = ["历史", "地理", "政治"];
          this.specialtyOptionsParam.disciplines = ["历史", "地理", "政治"];
        }
        if (
            this.studentInfo.disciplineType === 0 ||
            this.studentInfo.disciplineType === 3 ||
            this.studentInfo.disciplineType === 4
        ) {
          this.collegeParam.disciplines =
              this.studentInfo.discipline.split(",") || [];
          this.specialtyParam.disciplines =
              this.studentInfo.discipline.split(",") || [];
          this.specialtyOptionsParam.disciplines =
              this.studentInfo.discipline.split(",") || [];
        }
        this.collegeParam.score = this.studentInfo.adminScore;
        this.specialtyOptionsParam.score = this.studentInfo.adminScore;
        this.collegeParam.year = this.studentInfo.graduateYear;
        this.specialtyOptionsParam.year = this.studentInfo.graduateYear;
        this.specialtyParam.year = this.studentInfo.graduateYear;
        this.collegeParam.provinceId = this.studentInfo.province;
        this.specialtyParam.provinceId = this.studentInfo.province;
        this.specialtyOptionsParam.provinceId = this.studentInfo.province;
        if (!this.studentInfo.scores) {
          this.studentInfo.scores = {accumulate: null};
        }
        if (this.studentInfo.scores) {
          this.collegeParam.accumulate = this.studentInfo.scores.accumulate;
          this.specialtyParam.accumulate = this.studentInfo.scores.accumulate;
          this.specialtyOptionsParam.accumulate = this.studentInfo.scores.accumulate;
        }
        this.getProvincePage();
        this.selectEqualScore();
      });
    },
    //获取批次
    getProvincePage() {
      getProvincePage({
        year: this.studentInfo.graduateYear,
        areaProvinceId: this.studentInfo.province,
      }).then((res) => {
        let data = res.data || {};
        let records = data.records || [];
        if (records.length > 0) {
          this.batchList = records[0].batchs || [];

          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              this.currentBatch = {...item};
              this.volunteerMode = this.currentBatch.voPa;
            }
          });

          if (this.batchList.length > 0) {
            this.collegeParam.admitBatch = this.currentBatchName;
            this.specialtyParam.admitBatch = this.currentBatchName;
            this.specialtyOptionsParam.admitBatch = this.currentBatchName;
          }
        }
        if (this.draftId) {
          this.getDraftPlanDetail(this.draftId);
        } else {
          this.initYear();
        }
      });
    },
    // 评审
    systemAssess() {
      // 预录取
      previewAdmitDraft({draftId: this.draftId}).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "设置预录取成功",
            type: "success",
          });
        }
      });
      systemAssess({draftId: this.draftId}).then((res) => {
        if (res.code === 1) {
          this.$message({
            message: "评审完成",
            type: "success",
          });
        }
      });
    },
    /**
     * 获取志愿草稿详情
     * @param id
     */
    getDraftPlanDetail(id) {
      getDraftPlanDetail({draftId: id}).then((res) => {
        if (res.code === 1) {
          this.data = res.data || {};
          this.draftInfo = this.data;
          this.batchList = this.data.batchs || [];
          this.currentBatch = {};

          this.batchList.forEach((item) => {
            if (item.batch === this.currentBatchName) {
              this.draftCollegeList = item.collegeList || [];
              this.currentBatchName = this.data.admitBatch;
              this.collegeParam.admitBatch = this.currentBatchName;
              this.specialtyParam.admitBatch = this.currentBatchName;
              this.specialtyOptionsParam.admitBatch = this.currentBatchName;
              if (item.collegeList && item.collegeList.length > 0) {
                this.planYear = item.collegeList[0].year || this.planYear;
                this.admissionYear =
                    item.collegeList[0].admissionYear || this.admissionYear;
              }

              this.currentBatch = {...item};
              this.$refs.volunteerTable.refreshData(
                  this.currentBatch.collegeList
              );
            }
          });
        }
      });
    },
    // 初始化年份
    initYear() {
      let date = new Date();
      this.planYear = date.getFullYear();
      this.admissionYear = this.planYear - 1;
    },

    /**
     * 匹配院校类型
     * @param data
     * @returns {string}
     */
    matchRunType(data) {
      switch (data) {
        case 0:
          return "全部";
        case 1:
          return "公办";
        case 2:
          return "民办";
        case 3:
          return "其他";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  padding: 20px;

  .top {
    padding: 0px 10px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;

    span {
      margin-right: 10px;
      display: inline-block;
    }
  }

  /deep/ .el-dialog-div {
    overflow: auto !important;
  }

  .button {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
}
</style>
